<template>
  <div id="root">
    <div class="_container_1o1yz_18">
      <div class="_container_b8miy_1">
        <div class="slick-slider slick-initialized" dir="ltr"><button type="button" data-role="none"
            class="slick-arrow slick-prev" style="display: block;"> Previous</button>
          <div class="slick-list">
            <div class="slick-track" style="width: 21120px; opacity: 1; transform: translate3d(-5760px, 0px, 0px);">
              <div data-index="-1" tabindex="-1" class="slick-slide slick-cloned" aria-hidden="true"
                style="width: 1920px;">
                <div>
                  <div class="_sliderItem_b8miy_32">
                    <div class="_content_b8miy_48">
                      <div class="_title_b8miy_67">闪电移动开发</div>
                      <p class="_slogan_b8miy_58">闪电集成了移动客户端组件和移动组件接入与（云、本地）配置、移动分析、运营体系、APM等服务的一站式移动服务平台，为业务研发效能赋能
                      </p>
                      <div class="_buttonGroup_b8miy_79"><a href=""
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">了解详情</a><a
                          href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">立即体验</a></div>
                    </div>
                    <div class="_bg_b8miy_39"
                      style="background: url(&quot;http://cdnimg103.lizhi.fm/web_res/sounddoc/2022/01/21/2919568426818708992.png&quot;) center center / cover no-repeat;">
                    </div>
                  </div>
                </div>
              </div>
              <div data-index="0" class="slick-slide" tabindex="-1" aria-hidden="true"
                style="outline: none; width: 1920px;">
                <div>
                  <div class="_sliderItem_b8miy_32">
                    <div class="_content_b8miy_48">
                      <div class="_title_b8miy_67">声音云</div>
                      <p class="_slogan_b8miy_58">具备先进创新的技术能力，提供系统化全链路解决方案</p>
                      <div class="_buttonGroup_b8miy_79"><a href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">了解详情</a><a
                          href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">立即体验</a></div>
                    </div>
                    <div class="_bg_b8miy_39"
                      style="background: url(&quot;./assets/vico/banner.9567cbc3.jpeg&quot;) center center / cover no-repeat;">
                    </div>
                  </div>
                </div>
              </div>
              <div data-index="1" class="slick-slide" tabindex="-1" aria-hidden="true"
                style="outline: none; width: 1920px;">
                <div>
                  <div class="_sliderItem_b8miy_32">
                    <div class="_content_b8miy_48">
                      <div class="_title_b8miy_67">即时消息通讯(VoderX)</div>
                      <p class="_slogan_b8miy_58">VoderX即时通讯系统架构可以在原有应用中无缝接入，提供安全，快速，可靠的即时通讯服务。</p>
                      <div class="_buttonGroup_b8miy_79"><a href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">了解详情</a><a
                          href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">立即体验</a></div>
                    </div>
                    <div class="_bg_b8miy_39"
                      style="background: url(&quot;http://cdnimg103.lizhi.fm/web_res/sounddoc/2021/12/08/2911425810922700288.png&quot;) center center / cover no-repeat;">
                    </div>
                  </div>
                </div>
              </div>
              <div data-index="2" class="slick-slide slick-active slick-current" tabindex="-1" aria-hidden="false"
                style="outline: none; width: 1920px;">
                <div>
                  <div class="_sliderItem_b8miy_32">
                    <div class="_content_b8miy_48">
                      <div class="_title_b8miy_67">全球信令接入(Roma)</div>
                      <p class="_slogan_b8miy_58">七层流量接入系统，支持丰富接入协议，面向多租户架构，高级负载均衡</p>
                      <div class="_buttonGroup_b8miy_79"><a href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">了解详情</a><a
                          href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">立即体验</a></div>
                    </div>
                    <div class="_bg_b8miy_39"
                      style="background: url(&quot;http://cdnimg103.lizhi.fm/web_res/sounddoc/2021/12/08/2911425746791468032.png&quot;) center center / cover no-repeat;">
                    </div>
                  </div>
                </div>
              </div>
              <div data-index="3" class="slick-slide" tabindex="-1" aria-hidden="true"
                style="outline: none; width: 1920px;">
                <div>
                  <div class="_sliderItem_b8miy_32">
                    <div class="_content_b8miy_48">
                      <div class="_title_b8miy_67">混合云</div>
                      <p class="_slogan_b8miy_58">混合云平台，支持多租户以统一模型管理多云资源，ALL CLOUD IN ONE，ONE CLOUD FOR ALL</p>
                      <div class="_buttonGroup_b8miy_79"><a href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">了解详情</a><a
                          href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">立即体验</a></div>
                    </div>
                    <div class="_bg_b8miy_39"
                      style="background: url(&quot;http://cdnimg103.lizhi.fm/web_res/sounddoc/2021/12/28/2915123316055516160.png&quot;) center center / cover no-repeat;">
                    </div>
                  </div>
                </div>
              </div>
              <div data-index="4" class="slick-slide" tabindex="-1" aria-hidden="true"
                style="outline: none; width: 1920px;">
                <div>
                  <div class="_sliderItem_b8miy_32">
                    <div class="_content_b8miy_48">
                      <div class="_title_b8miy_67">闪电移动开发</div>
                      <p class="_slogan_b8miy_58">闪电集成了移动客户端组件和移动组件接入与（云、本地）配置、移动分析、运营体系、APM等服务的一站式移动服务平台，为业务研发效能赋能
                      </p>
                      <div class="_buttonGroup_b8miy_79"><a href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">了解详情</a><a
                          href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">立即体验</a></div>
                    </div>
                    <div class="_bg_b8miy_39"
                      style="background: url(&quot;http://cdnimg103.lizhi.fm/web_res/sounddoc/2022/01/21/2919568426818708992.png&quot;) center center / cover no-repeat;">
                    </div>
                  </div>
                </div>
              </div>
              <div data-index="5" tabindex="-1" class="slick-slide slick-cloned" aria-hidden="true"
                style="width: 1920px;">
                <div>
                  <div class="_sliderItem_b8miy_32">
                    <div class="_content_b8miy_48">
                      <div class="_title_b8miy_67">声音云</div>
                      <p class="_slogan_b8miy_58">具备先进创新的技术能力，提供系统化全链路解决方案</p>
                      <div class="_buttonGroup_b8miy_79"><a href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">了解详情</a><a
                          href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">立即体验</a></div>
                    </div>
                    <div class="_bg_b8miy_39"
                      style="background: url(&quot;./assets/vico/banner.9567cbc3.jpeg&quot;) center center / cover no-repeat;">
                    </div>
                  </div>
                </div>
              </div>
              <div data-index="6" tabindex="-1" class="slick-slide slick-cloned" aria-hidden="true"
                style="width: 1920px;">
                <div>
                  <div class="_sliderItem_b8miy_32">
                    <div class="_content_b8miy_48">
                      <div class="_title_b8miy_67">即时消息通讯(VoderX)</div>
                      <p class="_slogan_b8miy_58">VoderX即时通讯系统架构可以在原有应用中无缝接入，提供安全，快速，可靠的即时通讯服务。</p>
                      <div class="_buttonGroup_b8miy_79"><a href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">了解详情</a><a
                          href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">立即体验</a></div>
                    </div>
                    <div class="_bg_b8miy_39"
                      style="background: url(&quot;http://cdnimg103.lizhi.fm/web_res/sounddoc/2021/12/08/2911425810922700288.png&quot;) center center / cover no-repeat;">
                    </div>
                  </div>
                </div>
              </div>
              <div data-index="7" tabindex="-1" class="slick-slide slick-cloned" aria-hidden="true"
                style="width: 1920px;">
                <div>
                  <div class="_sliderItem_b8miy_32">
                    <div class="_content_b8miy_48">
                      <div class="_title_b8miy_67">全球信令接入(Roma)</div>
                      <p class="_slogan_b8miy_58">七层流量接入系统，支持丰富接入协议，面向多租户架构，高级负载均衡</p>
                      <div class="_buttonGroup_b8miy_79"><a href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">了解详情</a><a
                          href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">立即体验</a></div>
                    </div>
                    <div class="_bg_b8miy_39"
                      style="background: url(&quot;http://cdnimg103.lizhi.fm/web_res/sounddoc/2021/12/08/2911425746791468032.png&quot;) center center / cover no-repeat;">
                    </div>
                  </div>
                </div>
              </div>
              <div data-index="8" tabindex="-1" class="slick-slide slick-cloned" aria-hidden="true"
                style="width: 1920px;">
                <div>
                  <div class="_sliderItem_b8miy_32">
                    <div class="_content_b8miy_48">
                      <div class="_title_b8miy_67">混合云</div>
                      <p class="_slogan_b8miy_58">混合云平台，支持多租户以统一模型管理多云资源，ALL CLOUD IN ONE，ONE CLOUD FOR ALL</p>
                      <div class="_buttonGroup_b8miy_79"><a href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">了解详情</a><a
                          href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">立即体验</a></div>
                    </div>
                    <div class="_bg_b8miy_39"
                      style="background: url(&quot;http://cdnimg103.lizhi.fm/web_res/sounddoc/2021/12/28/2915123316055516160.png&quot;) center center / cover no-repeat;">
                    </div>
                  </div>
                </div>
              </div>
              <div data-index="9" tabindex="-1" class="slick-slide slick-cloned" aria-hidden="true"
                style="width: 1920px;">
                <div>
                  <div class="_sliderItem_b8miy_32">
                    <div class="_content_b8miy_48">
                      <div class="_title_b8miy_67">闪电移动开发</div>
                      <p class="_slogan_b8miy_58">闪电集成了移动客户端组件和移动组件接入与（云、本地）配置、移动分析、运营体系、APM等服务的一站式移动服务平台，为业务研发效能赋能
                      </p>
                      <div class="_buttonGroup_b8miy_79"><a href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">了解详情</a><a
                          href="javascript:void 0"
                          class="_button_1jvl8_1 _primary_1jvl8_31 _button_b8miy_79">立即体验</a></div>
                    </div>
                    <div class="_bg_b8miy_39"
                      style="background: url(&quot;http://cdnimg103.lizhi.fm/web_res/sounddoc/2022/01/21/2919568426818708992.png&quot;) center center / cover no-repeat;">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div><button type="button" data-role="none" class="slick-arrow slick-next" style="display: block;">
            Next</button>
          <ul class="slick-dots" style="display: block;">
            <li class=""><button>1</button></li>
            <li class=""><button>2</button></li>
            <li class="slick-active"><button>3</button></li>
            <li class=""><button>4</button></li>
            <li class=""><button>5</button></li>
          </ul>
        </div>
      </div>
      <div class="_feature_3a6kq_1">
        <div class="_featureItem_3a6kq_12">
          <div class="_cover_3a6kq_23"><img src="./assets/vico/icon3.2f327026.png"></div>
          <div class="_content_3a6kq_36">
            <div class="_title_3a6kq_42">通信音频</div>
            <div class="_description_3a6kq_49">让声音社交业务个性化</div>
          </div>
        </div>
        <div class="_featureItem_3a6kq_12">
          <div class="_cover_3a6kq_23"><img src="./assets/vico/icon2.e9202d0c.png"></div>
          <div class="_content_3a6kq_36">
            <div class="_title_3a6kq_42">研发效能</div>
            <div class="_description_3a6kq_49">快速构建应用，助理提效</div>
          </div>
        </div>
        <div class="_featureItem_3a6kq_12">
          <div class="_cover_3a6kq_23"><img src="./assets/vico/icon4.047248ff.png"></div>
          <div class="_content_3a6kq_36">
            <div class="_title_3a6kq_42">全球布局</div>
            <div class="_description_3a6kq_49">全球网络通信，多云统一</div>
          </div>
        </div>
        <div class="_featureItem_3a6kq_12">
          <div class="_cover_3a6kq_23"><img src="./assets/vico/icon1.33d346ed.png"></div>
          <div class="_content_3a6kq_36">
            <div class="_title_3a6kq_42">文档中心</div>
            <div class="_description_3a6kq_49">新手引导快速上手</div>
          </div>
        </div>
      </div>
      <div class="_introduction_1v56m_1">
        <div class="_introductionItem_1v56m_7">
          <div class="_content_1v56m_19">
            <div class="_title_1v56m_26">丰富多彩的声音社交技术服务</div>
            <div class="_description_1v56m_32">提供基于声音、社交属性的技术能力，满足稳定清晰的实时语音通信及快速安全的即时通讯服务系统，丰富功能及个性化创新能力</div>
            <div class="_desc_1v56m_32">
              <div class="_tag_1amn3_1"><img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAuCAYAAABEbmvDAAAAAXNSR0IArs4c6QAABYhJREFUWEftmGtMFFcUx/9nZvYBLAhat6BUIaVUqfiqbaytdQEt8VPV4gPdjfigGF8xadVUpNm2Sm1sbFpj22hSHwhRaaUN1mhqBbTRNLYq4CtVAfERJVUKuLDL7Nzb7BLAdReYBdQv7KfNzv/8z2/OPXvnziH0xudE6iQtxIzmuw4LZuUrvWFJPTY5YUkWOTsgcQohUL7d8F8axhU29tS3+2BFSw0BQoNV4XwVAWIrSDNwlUssA2/lFfUEzm+wmMMrQqoCaxdrgdUKEN5R8kCOX52CJrth0s5T3QFUBTa6aFroJSEwUcOF6Q7w6SIoSG0yEShnwD6Fs8OyKa8UBK4mlgaUWBIVyAZGkrtp6zmCdEwI0xEbXA/ESEC8CMQBENQYdqaRCbVahrOKgMsyqCqEo8bGeYOiERwhjAl2znTNdvEPJOfUkKF43ikZ9EZPk/ZWvENiia7+7ANTW9G+iqmtVKuur2J9FfO3Ar70RpIw/7nX8VrocKRf3Yk6sDbZM+mx4VIglkdOxYyIBIRp+0FhCpaUfYGcusvPBixGDMCqyKmYHfkOgqWWx+ztpntYe+l7/PjwmkdRn0rFAkBYE27CkugUhGlD2gCKa85g+T87cE1p8lrpJw6WEhKDj19KQ6xhaFtyhTN8V5GPD28d6rBVVYO57nr9oCkgIqy7fbTL3h8i6rEhaiZSBk+GQO0HEpuzCR9d2obttaWdeqgCm2aIhjV2AYYFR7vNdlQVYMWNgx0aW/oNx6fD0hGhH+ihue+oxZLyL1Foq+7yxlSB7X7RjNmRyR5meTePYGFFrsdvRtJgU/RMzIlM9qiSS1TddBeLyjbjpL2mSyiXQBWYaxkL4lbCNHCch+kvd4qQdnUnmsCRFBCBr+KWefRSq/j6w5uYU7YJ5XK9KijVYC5huKBF4ci1iO8X62H+271TKL5fiszYNARKAV6JK223kVqajfN+QPkF5hKPkIJxcEwWhgRGqLrzG413MKc0G+ea61TpHxW1LaW+xPw750jsymGi3oj9o7PQXxfaqdTV6DPOWfGn40FXlj6vOyBMgGnPaRJL5v0scXpXjcv04Cj8MDITAZLep9yuNGNB6UYUNFSosfMNxikeCTkXSFNi3ipwLFfrlBE2GltGrIIotL3jukM551h7cSu+uX9GrZWXTgbnTI9QjM+tJxRb0nXg2/1xWx9uQmbsQvem2/rZXV2IjMoD/tj4Aqtiplz3pkk4aR6lU3DeX8dtUe9h0dBp7rArDZVIOGdFLW8/vvjr1wLD8u2mvFkt311vssXzKjWgKH/NfopNR5JxPFLOZuFY4x1/w730EofZlrDXvXu3rEWJJVPH+QZ/nQ0kICUkDrvqLvgb6qXnRA+M9+yRt2blu48cbrD4Q3PDLhqECg3Q+V7Q4/QdG4ic1jcm5GxsVbR1r6HYslIG//oJ5u7QmoBKu6FuxKNztfa/FbcKASeuH2ecT3qacBxQGNgUp8lznuYxhjIeS32+QRTOMKIXniLcGodp7+bH83nNxwYUpQ57IIglWg7jk4aTBWxhb+/9wFcen4O76OPml6uJH5WI2s/FvUzp2gXqE3KzOrLteKJ4xBwh6Wm/CD6xN5kEQqPEaFlDQs6uznw7H3UWQdLyuZ/IAq3RgqSeAiqgsv5OstRM3lPWlZeqGSxOm8fqHNgBYGxXhr6uM+JNCsemMYagz/8et11W46EODIDVahU+M12bT8Q3iJwGqTGXCYyB9sGprENS3g01MV4brNqgqKI0/b9wLnYSVnNgiK84194EUH6zzLIxJbdcrfejOtUVe9z81b/e11yx2WZyRksVwpuu667nnZP4Lo0sf+tI2n+9O0DdrpjPZCfNo4IYf8WmMRZgwlfe7/3dIOx2xbqRy6+Q/wHfUFBNcg3G5QAAAABJRU5ErkJggg==">实时稳定
              </div>
              <div class="_tag_1amn3_1"><img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAuCAYAAABEbmvDAAAAAXNSR0IArs4c6QAABYhJREFUWEftmGtMFFcUx/9nZvYBLAhat6BUIaVUqfiqbaytdQEt8VPV4gPdjfigGF8xadVUpNm2Sm1sbFpj22hSHwhRaaUN1mhqBbTRNLYq4CtVAfERJVUKuLDL7Nzb7BLAdReYBdQv7KfNzv/8z2/OPXvnziH0xudE6iQtxIzmuw4LZuUrvWFJPTY5YUkWOTsgcQohUL7d8F8axhU29tS3+2BFSw0BQoNV4XwVAWIrSDNwlUssA2/lFfUEzm+wmMMrQqoCaxdrgdUKEN5R8kCOX52CJrth0s5T3QFUBTa6aFroJSEwUcOF6Q7w6SIoSG0yEShnwD6Fs8OyKa8UBK4mlgaUWBIVyAZGkrtp6zmCdEwI0xEbXA/ESEC8CMQBENQYdqaRCbVahrOKgMsyqCqEo8bGeYOiERwhjAl2znTNdvEPJOfUkKF43ikZ9EZPk/ZWvENiia7+7ANTW9G+iqmtVKuur2J9FfO3Ar70RpIw/7nX8VrocKRf3Yk6sDbZM+mx4VIglkdOxYyIBIRp+0FhCpaUfYGcusvPBixGDMCqyKmYHfkOgqWWx+ztpntYe+l7/PjwmkdRn0rFAkBYE27CkugUhGlD2gCKa85g+T87cE1p8lrpJw6WEhKDj19KQ6xhaFtyhTN8V5GPD28d6rBVVYO57nr9oCkgIqy7fbTL3h8i6rEhaiZSBk+GQO0HEpuzCR9d2obttaWdeqgCm2aIhjV2AYYFR7vNdlQVYMWNgx0aW/oNx6fD0hGhH+ihue+oxZLyL1Foq+7yxlSB7X7RjNmRyR5meTePYGFFrsdvRtJgU/RMzIlM9qiSS1TddBeLyjbjpL2mSyiXQBWYaxkL4lbCNHCch+kvd4qQdnUnmsCRFBCBr+KWefRSq/j6w5uYU7YJ5XK9KijVYC5huKBF4ci1iO8X62H+271TKL5fiszYNARKAV6JK223kVqajfN+QPkF5hKPkIJxcEwWhgRGqLrzG413MKc0G+ea61TpHxW1LaW+xPw750jsymGi3oj9o7PQXxfaqdTV6DPOWfGn40FXlj6vOyBMgGnPaRJL5v0scXpXjcv04Cj8MDITAZLep9yuNGNB6UYUNFSosfMNxikeCTkXSFNi3ipwLFfrlBE2GltGrIIotL3jukM551h7cSu+uX9GrZWXTgbnTI9QjM+tJxRb0nXg2/1xWx9uQmbsQvem2/rZXV2IjMoD/tj4Aqtiplz3pkk4aR6lU3DeX8dtUe9h0dBp7rArDZVIOGdFLW8/vvjr1wLD8u2mvFkt311vssXzKjWgKH/NfopNR5JxPFLOZuFY4x1/w730EofZlrDXvXu3rEWJJVPH+QZ/nQ0kICUkDrvqLvgb6qXnRA+M9+yRt2blu48cbrD4Q3PDLhqECg3Q+V7Q4/QdG4ic1jcm5GxsVbR1r6HYslIG//oJ5u7QmoBKu6FuxKNztfa/FbcKASeuH2ecT3qacBxQGNgUp8lznuYxhjIeS32+QRTOMKIXniLcGodp7+bH83nNxwYUpQ57IIglWg7jk4aTBWxhb+/9wFcen4O76OPml6uJH5WI2s/FvUzp2gXqE3KzOrLteKJ4xBwh6Wm/CD6xN5kEQqPEaFlDQs6uznw7H3UWQdLyuZ/IAq3RgqSeAiqgsv5OstRM3lPWlZeqGSxOm8fqHNgBYGxXhr6uM+JNCsemMYagz/8et11W46EODIDVahU+M12bT8Q3iJwGqTGXCYyB9sGprENS3g01MV4brNqgqKI0/b9wLnYSVnNgiK84194EUH6zzLIxJbdcrfejOtUVe9z81b/e11yx2WZyRksVwpuu667nnZP4Lo0sf+tI2n+9O0DdrpjPZCfNo4IYf8WmMRZgwlfe7/3dIOx2xbqRy6+Q/wHfUFBNcg3G5QAAAABJRU5ErkJggg==">快速安全
              </div>
            </div>
          </div>
          <div class="_icon_1v56m_45">
            <div class="_bg_1v56m_59"></div><img class="_iconImage_1v56m_54" src="./assets/vico/icon1.df44ae13.png">
          </div>
        </div>
        <div class="_introductionItem_1v56m_7 _right_1v56m_70">
          <div class="_content_1v56m_19">
            <div class="_title_1v56m_26">便捷研发工具、数据监控体系</div>
            <div class="_description_1v56m_32">集成移动组件、配置、分析、运营、数据监控全面的一站式移动研发平台，为业务研发效率赋能</div>
            <div class="_desc_1v56m_32">
              <div class="_tag_1amn3_1"><img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAuCAYAAABEbmvDAAAAAXNSR0IArs4c6QAABYhJREFUWEftmGtMFFcUx/9nZvYBLAhat6BUIaVUqfiqbaytdQEt8VPV4gPdjfigGF8xadVUpNm2Sm1sbFpj22hSHwhRaaUN1mhqBbTRNLYq4CtVAfERJVUKuLDL7Nzb7BLAdReYBdQv7KfNzv/8z2/OPXvnziH0xudE6iQtxIzmuw4LZuUrvWFJPTY5YUkWOTsgcQohUL7d8F8axhU29tS3+2BFSw0BQoNV4XwVAWIrSDNwlUssA2/lFfUEzm+wmMMrQqoCaxdrgdUKEN5R8kCOX52CJrth0s5T3QFUBTa6aFroJSEwUcOF6Q7w6SIoSG0yEShnwD6Fs8OyKa8UBK4mlgaUWBIVyAZGkrtp6zmCdEwI0xEbXA/ESEC8CMQBENQYdqaRCbVahrOKgMsyqCqEo8bGeYOiERwhjAl2znTNdvEPJOfUkKF43ikZ9EZPk/ZWvENiia7+7ANTW9G+iqmtVKuur2J9FfO3Ar70RpIw/7nX8VrocKRf3Yk6sDbZM+mx4VIglkdOxYyIBIRp+0FhCpaUfYGcusvPBixGDMCqyKmYHfkOgqWWx+ztpntYe+l7/PjwmkdRn0rFAkBYE27CkugUhGlD2gCKa85g+T87cE1p8lrpJw6WEhKDj19KQ6xhaFtyhTN8V5GPD28d6rBVVYO57nr9oCkgIqy7fbTL3h8i6rEhaiZSBk+GQO0HEpuzCR9d2obttaWdeqgCm2aIhjV2AYYFR7vNdlQVYMWNgx0aW/oNx6fD0hGhH+ihue+oxZLyL1Foq+7yxlSB7X7RjNmRyR5meTePYGFFrsdvRtJgU/RMzIlM9qiSS1TddBeLyjbjpL2mSyiXQBWYaxkL4lbCNHCch+kvd4qQdnUnmsCRFBCBr+KWefRSq/j6w5uYU7YJ5XK9KijVYC5huKBF4ci1iO8X62H+271TKL5fiszYNARKAV6JK223kVqajfN+QPkF5hKPkIJxcEwWhgRGqLrzG413MKc0G+ea61TpHxW1LaW+xPw750jsymGi3oj9o7PQXxfaqdTV6DPOWfGn40FXlj6vOyBMgGnPaRJL5v0scXpXjcv04Cj8MDITAZLep9yuNGNB6UYUNFSosfMNxikeCTkXSFNi3ipwLFfrlBE2GltGrIIotL3jukM551h7cSu+uX9GrZWXTgbnTI9QjM+tJxRb0nXg2/1xWx9uQmbsQvem2/rZXV2IjMoD/tj4Aqtiplz3pkk4aR6lU3DeX8dtUe9h0dBp7rArDZVIOGdFLW8/vvjr1wLD8u2mvFkt311vssXzKjWgKH/NfopNR5JxPFLOZuFY4x1/w730EofZlrDXvXu3rEWJJVPH+QZ/nQ0kICUkDrvqLvgb6qXnRA+M9+yRt2blu48cbrD4Q3PDLhqECg3Q+V7Q4/QdG4ic1jcm5GxsVbR1r6HYslIG//oJ5u7QmoBKu6FuxKNztfa/FbcKASeuH2ecT3qacBxQGNgUp8lznuYxhjIeS32+QRTOMKIXniLcGodp7+bH83nNxwYUpQ57IIglWg7jk4aTBWxhb+/9wFcen4O76OPml6uJH5WI2s/FvUzp2gXqE3KzOrLteKJ4xBwh6Wm/CD6xN5kEQqPEaFlDQs6uznw7H3UWQdLyuZ/IAq3RgqSeAiqgsv5OstRM3lPWlZeqGSxOm8fqHNgBYGxXhr6uM+JNCsemMYagz/8et11W46EODIDVahU+M12bT8Q3iJwGqTGXCYyB9sGprENS3g01MV4brNqgqKI0/b9wLnYSVnNgiK84194EUH6zzLIxJbdcrfejOtUVe9z81b/e11yx2WZyRksVwpuu667nnZP4Lo0sf+tI2n+9O0DdrpjPZCfNo4IYf8WmMRZgwlfe7/3dIOx2xbqRy6+Q/wHfUFBNcg3G5QAAAABJRU5ErkJggg==">标准组件化
              </div>
              <div class="_tag_1amn3_1"><img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAuCAYAAABEbmvDAAAAAXNSR0IArs4c6QAABYhJREFUWEftmGtMFFcUx/9nZvYBLAhat6BUIaVUqfiqbaytdQEt8VPV4gPdjfigGF8xadVUpNm2Sm1sbFpj22hSHwhRaaUN1mhqBbTRNLYq4CtVAfERJVUKuLDL7Nzb7BLAdReYBdQv7KfNzv/8z2/OPXvnziH0xudE6iQtxIzmuw4LZuUrvWFJPTY5YUkWOTsgcQohUL7d8F8axhU29tS3+2BFSw0BQoNV4XwVAWIrSDNwlUssA2/lFfUEzm+wmMMrQqoCaxdrgdUKEN5R8kCOX52CJrth0s5T3QFUBTa6aFroJSEwUcOF6Q7w6SIoSG0yEShnwD6Fs8OyKa8UBK4mlgaUWBIVyAZGkrtp6zmCdEwI0xEbXA/ESEC8CMQBENQYdqaRCbVahrOKgMsyqCqEo8bGeYOiERwhjAl2znTNdvEPJOfUkKF43ikZ9EZPk/ZWvENiia7+7ANTW9G+iqmtVKuur2J9FfO3Ar70RpIw/7nX8VrocKRf3Yk6sDbZM+mx4VIglkdOxYyIBIRp+0FhCpaUfYGcusvPBixGDMCqyKmYHfkOgqWWx+ztpntYe+l7/PjwmkdRn0rFAkBYE27CkugUhGlD2gCKa85g+T87cE1p8lrpJw6WEhKDj19KQ6xhaFtyhTN8V5GPD28d6rBVVYO57nr9oCkgIqy7fbTL3h8i6rEhaiZSBk+GQO0HEpuzCR9d2obttaWdeqgCm2aIhjV2AYYFR7vNdlQVYMWNgx0aW/oNx6fD0hGhH+ihue+oxZLyL1Foq+7yxlSB7X7RjNmRyR5meTePYGFFrsdvRtJgU/RMzIlM9qiSS1TddBeLyjbjpL2mSyiXQBWYaxkL4lbCNHCch+kvd4qQdnUnmsCRFBCBr+KWefRSq/j6w5uYU7YJ5XK9KijVYC5huKBF4ci1iO8X62H+271TKL5fiszYNARKAV6JK223kVqajfN+QPkF5hKPkIJxcEwWhgRGqLrzG413MKc0G+ea61TpHxW1LaW+xPw750jsymGi3oj9o7PQXxfaqdTV6DPOWfGn40FXlj6vOyBMgGnPaRJL5v0scXpXjcv04Cj8MDITAZLep9yuNGNB6UYUNFSosfMNxikeCTkXSFNi3ipwLFfrlBE2GltGrIIotL3jukM551h7cSu+uX9GrZWXTgbnTI9QjM+tJxRb0nXg2/1xWx9uQmbsQvem2/rZXV2IjMoD/tj4Aqtiplz3pkk4aR6lU3DeX8dtUe9h0dBp7rArDZVIOGdFLW8/vvjr1wLD8u2mvFkt311vssXzKjWgKH/NfopNR5JxPFLOZuFY4x1/w730EofZlrDXvXu3rEWJJVPH+QZ/nQ0kICUkDrvqLvgb6qXnRA+M9+yRt2blu48cbrD4Q3PDLhqECg3Q+V7Q4/QdG4ic1jcm5GxsVbR1r6HYslIG//oJ5u7QmoBKu6FuxKNztfa/FbcKASeuH2ecT3qacBxQGNgUp8lznuYxhjIeS32+QRTOMKIXniLcGodp7+bH83nNxwYUpQ57IIglWg7jk4aTBWxhb+/9wFcen4O76OPml6uJH5WI2s/FvUzp2gXqE3KzOrLteKJ4xBwh6Wm/CD6xN5kEQqPEaFlDQs6uznw7H3UWQdLyuZ/IAq3RgqSeAiqgsv5OstRM3lPWlZeqGSxOm8fqHNgBYGxXhr6uM+JNCsemMYagz/8et11W46EODIDVahU+M12bT8Q3iJwGqTGXCYyB9sGprENS3g01MV4brNqgqKI0/b9wLnYSVnNgiK84194EUH6zzLIxJbdcrfejOtUVe9z81b/e11yx2WZyRksVwpuu667nnZP4Lo0sf+tI2n+9O0DdrpjPZCfNo4IYf8WmMRZgwlfe7/3dIOx2xbqRy6+Q/wHfUFBNcg3G5QAAAABJRU5ErkJggg==">云配置
              </div>
              <div class="_tag_1amn3_1"><img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAuCAYAAABEbmvDAAAAAXNSR0IArs4c6QAABYhJREFUWEftmGtMFFcUx/9nZvYBLAhat6BUIaVUqfiqbaytdQEt8VPV4gPdjfigGF8xadVUpNm2Sm1sbFpj22hSHwhRaaUN1mhqBbTRNLYq4CtVAfERJVUKuLDL7Nzb7BLAdReYBdQv7KfNzv/8z2/OPXvnziH0xudE6iQtxIzmuw4LZuUrvWFJPTY5YUkWOTsgcQohUL7d8F8axhU29tS3+2BFSw0BQoNV4XwVAWIrSDNwlUssA2/lFfUEzm+wmMMrQqoCaxdrgdUKEN5R8kCOX52CJrth0s5T3QFUBTa6aFroJSEwUcOF6Q7w6SIoSG0yEShnwD6Fs8OyKa8UBK4mlgaUWBIVyAZGkrtp6zmCdEwI0xEbXA/ESEC8CMQBENQYdqaRCbVahrOKgMsyqCqEo8bGeYOiERwhjAl2znTNdvEPJOfUkKF43ikZ9EZPk/ZWvENiia7+7ANTW9G+iqmtVKuur2J9FfO3Ar70RpIw/7nX8VrocKRf3Yk6sDbZM+mx4VIglkdOxYyIBIRp+0FhCpaUfYGcusvPBixGDMCqyKmYHfkOgqWWx+ztpntYe+l7/PjwmkdRn0rFAkBYE27CkugUhGlD2gCKa85g+T87cE1p8lrpJw6WEhKDj19KQ6xhaFtyhTN8V5GPD28d6rBVVYO57nr9oCkgIqy7fbTL3h8i6rEhaiZSBk+GQO0HEpuzCR9d2obttaWdeqgCm2aIhjV2AYYFR7vNdlQVYMWNgx0aW/oNx6fD0hGhH+ihue+oxZLyL1Foq+7yxlSB7X7RjNmRyR5meTePYGFFrsdvRtJgU/RMzIlM9qiSS1TddBeLyjbjpL2mSyiXQBWYaxkL4lbCNHCch+kvd4qQdnUnmsCRFBCBr+KWefRSq/j6w5uYU7YJ5XK9KijVYC5huKBF4ci1iO8X62H+271TKL5fiszYNARKAV6JK223kVqajfN+QPkF5hKPkIJxcEwWhgRGqLrzG413MKc0G+ea61TpHxW1LaW+xPw750jsymGi3oj9o7PQXxfaqdTV6DPOWfGn40FXlj6vOyBMgGnPaRJL5v0scXpXjcv04Cj8MDITAZLep9yuNGNB6UYUNFSosfMNxikeCTkXSFNi3ipwLFfrlBE2GltGrIIotL3jukM551h7cSu+uX9GrZWXTgbnTI9QjM+tJxRb0nXg2/1xWx9uQmbsQvem2/rZXV2IjMoD/tj4Aqtiplz3pkk4aR6lU3DeX8dtUe9h0dBp7rArDZVIOGdFLW8/vvjr1wLD8u2mvFkt311vssXzKjWgKH/NfopNR5JxPFLOZuFY4x1/w730EofZlrDXvXu3rEWJJVPH+QZ/nQ0kICUkDrvqLvgb6qXnRA+M9+yRt2blu48cbrD4Q3PDLhqECg3Q+V7Q4/QdG4ic1jcm5GxsVbR1r6HYslIG//oJ5u7QmoBKu6FuxKNztfa/FbcKASeuH2ecT3qacBxQGNgUp8lznuYxhjIeS32+QRTOMKIXniLcGodp7+bH83nNxwYUpQ57IIglWg7jk4aTBWxhb+/9wFcen4O76OPml6uJH5WI2s/FvUzp2gXqE3KzOrLteKJ4xBwh6Wm/CD6xN5kEQqPEaFlDQs6uznw7H3UWQdLyuZ/IAq3RgqSeAiqgsv5OstRM3lPWlZeqGSxOm8fqHNgBYGxXhr6uM+JNCsemMYagz/8et11W46EODIDVahU+M12bT8Q3iJwGqTGXCYyB9sGprENS3g01MV4brNqgqKI0/b9wLnYSVnNgiK84194EUH6zzLIxJbdcrfejOtUVe9z81b/e11yx2WZyRksVwpuu667nnZP4Lo0sf+tI2n+9O0DdrpjPZCfNo4IYf8WmMRZgwlfe7/3dIOx2xbqRy6+Q/wHfUFBNcg3G5QAAAABJRU5ErkJggg==">移动分析
              </div>
              <div class="_tag_1amn3_1"><img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAuCAYAAABEbmvDAAAAAXNSR0IArs4c6QAABYhJREFUWEftmGtMFFcUx/9nZvYBLAhat6BUIaVUqfiqbaytdQEt8VPV4gPdjfigGF8xadVUpNm2Sm1sbFpj22hSHwhRaaUN1mhqBbTRNLYq4CtVAfERJVUKuLDL7Nzb7BLAdReYBdQv7KfNzv/8z2/OPXvnziH0xudE6iQtxIzmuw4LZuUrvWFJPTY5YUkWOTsgcQohUL7d8F8axhU29tS3+2BFSw0BQoNV4XwVAWIrSDNwlUssA2/lFfUEzm+wmMMrQqoCaxdrgdUKEN5R8kCOX52CJrth0s5T3QFUBTa6aFroJSEwUcOF6Q7w6SIoSG0yEShnwD6Fs8OyKa8UBK4mlgaUWBIVyAZGkrtp6zmCdEwI0xEbXA/ESEC8CMQBENQYdqaRCbVahrOKgMsyqCqEo8bGeYOiERwhjAl2znTNdvEPJOfUkKF43ikZ9EZPk/ZWvENiia7+7ANTW9G+iqmtVKuur2J9FfO3Ar70RpIw/7nX8VrocKRf3Yk6sDbZM+mx4VIglkdOxYyIBIRp+0FhCpaUfYGcusvPBixGDMCqyKmYHfkOgqWWx+ztpntYe+l7/PjwmkdRn0rFAkBYE27CkugUhGlD2gCKa85g+T87cE1p8lrpJw6WEhKDj19KQ6xhaFtyhTN8V5GPD28d6rBVVYO57nr9oCkgIqy7fbTL3h8i6rEhaiZSBk+GQO0HEpuzCR9d2obttaWdeqgCm2aIhjV2AYYFR7vNdlQVYMWNgx0aW/oNx6fD0hGhH+ihue+oxZLyL1Foq+7yxlSB7X7RjNmRyR5meTePYGFFrsdvRtJgU/RMzIlM9qiSS1TddBeLyjbjpL2mSyiXQBWYaxkL4lbCNHCch+kvd4qQdnUnmsCRFBCBr+KWefRSq/j6w5uYU7YJ5XK9KijVYC5huKBF4ci1iO8X62H+271TKL5fiszYNARKAV6JK223kVqajfN+QPkF5hKPkIJxcEwWhgRGqLrzG413MKc0G+ea61TpHxW1LaW+xPw750jsymGi3oj9o7PQXxfaqdTV6DPOWfGn40FXlj6vOyBMgGnPaRJL5v0scXpXjcv04Cj8MDITAZLep9yuNGNB6UYUNFSosfMNxikeCTkXSFNi3ipwLFfrlBE2GltGrIIotL3jukM551h7cSu+uX9GrZWXTgbnTI9QjM+tJxRb0nXg2/1xWx9uQmbsQvem2/rZXV2IjMoD/tj4Aqtiplz3pkk4aR6lU3DeX8dtUe9h0dBp7rArDZVIOGdFLW8/vvjr1wLD8u2mvFkt311vssXzKjWgKH/NfopNR5JxPFLOZuFY4x1/w730EofZlrDXvXu3rEWJJVPH+QZ/nQ0kICUkDrvqLvgb6qXnRA+M9+yRt2blu48cbrD4Q3PDLhqECg3Q+V7Q4/QdG4ic1jcm5GxsVbR1r6HYslIG//oJ5u7QmoBKu6FuxKNztfa/FbcKASeuH2ecT3qacBxQGNgUp8lznuYxhjIeS32+QRTOMKIXniLcGodp7+bH83nNxwYUpQ57IIglWg7jk4aTBWxhb+/9wFcen4O76OPml6uJH5WI2s/FvUzp2gXqE3KzOrLteKJ4xBwh6Wm/CD6xN5kEQqPEaFlDQs6uznw7H3UWQdLyuZ/IAq3RgqSeAiqgsv5OstRM3lPWlZeqGSxOm8fqHNgBYGxXhr6uM+JNCsemMYagz/8et11W46EODIDVahU+M12bT8Q3iJwGqTGXCYyB9sGprENS3g01MV4brNqgqKI0/b9wLnYSVnNgiK84194EUH6zzLIxJbdcrfejOtUVe9z81b/e11yx2WZyRksVwpuu667nnZP4Lo0sf+tI2n+9O0DdrpjPZCfNo4IYf8WmMRZgwlfe7/3dIOx2xbqRy6+Q/wHfUFBNcg3G5QAAAABJRU5ErkJggg==">可视设计
              </div>
            </div>
          </div>
          <div class="_icon_1v56m_45">
            <div class="_bg_1v56m_59"></div><img class="_iconImage_1v56m_54" src="./assets/vico/icon2.83cae2e3.png">
          </div>
        </div>
        <div class="_introductionItem_1v56m_7">
          <div class="_content_1v56m_19">
            <div class="_title_1v56m_26">强大的网络保障</div>
            <div class="_description_1v56m_32">实时传输网络技术，及网络探测调度平台、高级负载均衡</div>
            <div class="_desc_1v56m_32">
              <div class="_tag_1amn3_1"><img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAuCAYAAABEbmvDAAAAAXNSR0IArs4c6QAABYhJREFUWEftmGtMFFcUx/9nZvYBLAhat6BUIaVUqfiqbaytdQEt8VPV4gPdjfigGF8xadVUpNm2Sm1sbFpj22hSHwhRaaUN1mhqBbTRNLYq4CtVAfERJVUKuLDL7Nzb7BLAdReYBdQv7KfNzv/8z2/OPXvnziH0xudE6iQtxIzmuw4LZuUrvWFJPTY5YUkWOTsgcQohUL7d8F8axhU29tS3+2BFSw0BQoNV4XwVAWIrSDNwlUssA2/lFfUEzm+wmMMrQqoCaxdrgdUKEN5R8kCOX52CJrth0s5T3QFUBTa6aFroJSEwUcOF6Q7w6SIoSG0yEShnwD6Fs8OyKa8UBK4mlgaUWBIVyAZGkrtp6zmCdEwI0xEbXA/ESEC8CMQBENQYdqaRCbVahrOKgMsyqCqEo8bGeYOiERwhjAl2znTNdvEPJOfUkKF43ikZ9EZPk/ZWvENiia7+7ANTW9G+iqmtVKuur2J9FfO3Ar70RpIw/7nX8VrocKRf3Yk6sDbZM+mx4VIglkdOxYyIBIRp+0FhCpaUfYGcusvPBixGDMCqyKmYHfkOgqWWx+ztpntYe+l7/PjwmkdRn0rFAkBYE27CkugUhGlD2gCKa85g+T87cE1p8lrpJw6WEhKDj19KQ6xhaFtyhTN8V5GPD28d6rBVVYO57nr9oCkgIqy7fbTL3h8i6rEhaiZSBk+GQO0HEpuzCR9d2obttaWdeqgCm2aIhjV2AYYFR7vNdlQVYMWNgx0aW/oNx6fD0hGhH+ihue+oxZLyL1Foq+7yxlSB7X7RjNmRyR5meTePYGFFrsdvRtJgU/RMzIlM9qiSS1TddBeLyjbjpL2mSyiXQBWYaxkL4lbCNHCch+kvd4qQdnUnmsCRFBCBr+KWefRSq/j6w5uYU7YJ5XK9KijVYC5huKBF4ci1iO8X62H+271TKL5fiszYNARKAV6JK223kVqajfN+QPkF5hKPkIJxcEwWhgRGqLrzG413MKc0G+ea61TpHxW1LaW+xPw750jsymGi3oj9o7PQXxfaqdTV6DPOWfGn40FXlj6vOyBMgGnPaRJL5v0scXpXjcv04Cj8MDITAZLep9yuNGNB6UYUNFSosfMNxikeCTkXSFNi3ipwLFfrlBE2GltGrIIotL3jukM551h7cSu+uX9GrZWXTgbnTI9QjM+tJxRb0nXg2/1xWx9uQmbsQvem2/rZXV2IjMoD/tj4Aqtiplz3pkk4aR6lU3DeX8dtUe9h0dBp7rArDZVIOGdFLW8/vvjr1wLD8u2mvFkt311vssXzKjWgKH/NfopNR5JxPFLOZuFY4x1/w730EofZlrDXvXu3rEWJJVPH+QZ/nQ0kICUkDrvqLvgb6qXnRA+M9+yRt2blu48cbrD4Q3PDLhqECg3Q+V7Q4/QdG4ic1jcm5GxsVbR1r6HYslIG//oJ5u7QmoBKu6FuxKNztfa/FbcKASeuH2ecT3qacBxQGNgUp8lznuYxhjIeS32+QRTOMKIXniLcGodp7+bH83nNxwYUpQ57IIglWg7jk4aTBWxhb+/9wFcen4O76OPml6uJH5WI2s/FvUzp2gXqE3KzOrLteKJ4xBwh6Wm/CD6xN5kEQqPEaFlDQs6uznw7H3UWQdLyuZ/IAq3RgqSeAiqgsv5OstRM3lPWlZeqGSxOm8fqHNgBYGxXhr6uM+JNCsemMYagz/8et11W46EODIDVahU+M12bT8Q3iJwGqTGXCYyB9sGprENS3g01MV4brNqgqKI0/b9wLnYSVnNgiK84194EUH6zzLIxJbdcrfejOtUVe9z81b/e11yx2WZyRksVwpuu667nnZP4Lo0sf+tI2n+9O0DdrpjPZCfNo4IYf8WmMRZgwlfe7/3dIOx2xbqRy6+Q/wHfUFBNcg3G5QAAAABJRU5ErkJggg==">可见性
              </div>
              <div class="_tag_1amn3_1"><img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAuCAYAAABEbmvDAAAAAXNSR0IArs4c6QAABYhJREFUWEftmGtMFFcUx/9nZvYBLAhat6BUIaVUqfiqbaytdQEt8VPV4gPdjfigGF8xadVUpNm2Sm1sbFpj22hSHwhRaaUN1mhqBbTRNLYq4CtVAfERJVUKuLDL7Nzb7BLAdReYBdQv7KfNzv/8z2/OPXvnziH0xudE6iQtxIzmuw4LZuUrvWFJPTY5YUkWOTsgcQohUL7d8F8axhU29tS3+2BFSw0BQoNV4XwVAWIrSDNwlUssA2/lFfUEzm+wmMMrQqoCaxdrgdUKEN5R8kCOX52CJrth0s5T3QFUBTa6aFroJSEwUcOF6Q7w6SIoSG0yEShnwD6Fs8OyKa8UBK4mlgaUWBIVyAZGkrtp6zmCdEwI0xEbXA/ESEC8CMQBENQYdqaRCbVahrOKgMsyqCqEo8bGeYOiERwhjAl2znTNdvEPJOfUkKF43ikZ9EZPk/ZWvENiia7+7ANTW9G+iqmtVKuur2J9FfO3Ar70RpIw/7nX8VrocKRf3Yk6sDbZM+mx4VIglkdOxYyIBIRp+0FhCpaUfYGcusvPBixGDMCqyKmYHfkOgqWWx+ztpntYe+l7/PjwmkdRn0rFAkBYE27CkugUhGlD2gCKa85g+T87cE1p8lrpJw6WEhKDj19KQ6xhaFtyhTN8V5GPD28d6rBVVYO57nr9oCkgIqy7fbTL3h8i6rEhaiZSBk+GQO0HEpuzCR9d2obttaWdeqgCm2aIhjV2AYYFR7vNdlQVYMWNgx0aW/oNx6fD0hGhH+ihue+oxZLyL1Foq+7yxlSB7X7RjNmRyR5meTePYGFFrsdvRtJgU/RMzIlM9qiSS1TddBeLyjbjpL2mSyiXQBWYaxkL4lbCNHCch+kvd4qQdnUnmsCRFBCBr+KWefRSq/j6w5uYU7YJ5XK9KijVYC5huKBF4ci1iO8X62H+271TKL5fiszYNARKAV6JK223kVqajfN+QPkF5hKPkIJxcEwWhgRGqLrzG413MKc0G+ea61TpHxW1LaW+xPw750jsymGi3oj9o7PQXxfaqdTV6DPOWfGn40FXlj6vOyBMgGnPaRJL5v0scXpXjcv04Cj8MDITAZLep9yuNGNB6UYUNFSosfMNxikeCTkXSFNi3ipwLFfrlBE2GltGrIIotL3jukM551h7cSu+uX9GrZWXTgbnTI9QjM+tJxRb0nXg2/1xWx9uQmbsQvem2/rZXV2IjMoD/tj4Aqtiplz3pkk4aR6lU3DeX8dtUe9h0dBp7rArDZVIOGdFLW8/vvjr1wLD8u2mvFkt311vssXzKjWgKH/NfopNR5JxPFLOZuFY4x1/w730EofZlrDXvXu3rEWJJVPH+QZ/nQ0kICUkDrvqLvgb6qXnRA+M9+yRt2blu48cbrD4Q3PDLhqECg3Q+V7Q4/QdG4ic1jcm5GxsVbR1r6HYslIG//oJ5u7QmoBKu6FuxKNztfa/FbcKASeuH2ecT3qacBxQGNgUp8lznuYxhjIeS32+QRTOMKIXniLcGodp7+bH83nNxwYUpQ57IIglWg7jk4aTBWxhb+/9wFcen4O76OPml6uJH5WI2s/FvUzp2gXqE3KzOrLteKJ4xBwh6Wm/CD6xN5kEQqPEaFlDQs6uznw7H3UWQdLyuZ/IAq3RgqSeAiqgsv5OstRM3lPWlZeqGSxOm8fqHNgBYGxXhr6uM+JNCsemMYagz/8et11W46EODIDVahU+M12bT8Q3iJwGqTGXCYyB9sGprENS3g01MV4brNqgqKI0/b9wLnYSVnNgiK84194EUH6zzLIxJbdcrfejOtUVe9z81b/e11yx2WZyRksVwpuu667nnZP4Lo0sf+tI2n+9O0DdrpjPZCfNo4IYf8WmMRZgwlfe7/3dIOx2xbqRy6+Q/wHfUFBNcg3G5QAAAABJRU5ErkJggg==">负载均衡
              </div>
              <div class="_tag_1amn3_1"><img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAuCAYAAABEbmvDAAAAAXNSR0IArs4c6QAABYhJREFUWEftmGtMFFcUx/9nZvYBLAhat6BUIaVUqfiqbaytdQEt8VPV4gPdjfigGF8xadVUpNm2Sm1sbFpj22hSHwhRaaUN1mhqBbTRNLYq4CtVAfERJVUKuLDL7Nzb7BLAdReYBdQv7KfNzv/8z2/OPXvnziH0xudE6iQtxIzmuw4LZuUrvWFJPTY5YUkWOTsgcQohUL7d8F8axhU29tS3+2BFSw0BQoNV4XwVAWIrSDNwlUssA2/lFfUEzm+wmMMrQqoCaxdrgdUKEN5R8kCOX52CJrth0s5T3QFUBTa6aFroJSEwUcOF6Q7w6SIoSG0yEShnwD6Fs8OyKa8UBK4mlgaUWBIVyAZGkrtp6zmCdEwI0xEbXA/ESEC8CMQBENQYdqaRCbVahrOKgMsyqCqEo8bGeYOiERwhjAl2znTNdvEPJOfUkKF43ikZ9EZPk/ZWvENiia7+7ANTW9G+iqmtVKuur2J9FfO3Ar70RpIw/7nX8VrocKRf3Yk6sDbZM+mx4VIglkdOxYyIBIRp+0FhCpaUfYGcusvPBixGDMCqyKmYHfkOgqWWx+ztpntYe+l7/PjwmkdRn0rFAkBYE27CkugUhGlD2gCKa85g+T87cE1p8lrpJw6WEhKDj19KQ6xhaFtyhTN8V5GPD28d6rBVVYO57nr9oCkgIqy7fbTL3h8i6rEhaiZSBk+GQO0HEpuzCR9d2obttaWdeqgCm2aIhjV2AYYFR7vNdlQVYMWNgx0aW/oNx6fD0hGhH+ihue+oxZLyL1Foq+7yxlSB7X7RjNmRyR5meTePYGFFrsdvRtJgU/RMzIlM9qiSS1TddBeLyjbjpL2mSyiXQBWYaxkL4lbCNHCch+kvd4qQdnUnmsCRFBCBr+KWefRSq/j6w5uYU7YJ5XK9KijVYC5huKBF4ci1iO8X62H+271TKL5fiszYNARKAV6JK223kVqajfN+QPkF5hKPkIJxcEwWhgRGqLrzG413MKc0G+ea61TpHxW1LaW+xPw750jsymGi3oj9o7PQXxfaqdTV6DPOWfGn40FXlj6vOyBMgGnPaRJL5v0scXpXjcv04Cj8MDITAZLep9yuNGNB6UYUNFSosfMNxikeCTkXSFNi3ipwLFfrlBE2GltGrIIotL3jukM551h7cSu+uX9GrZWXTgbnTI9QjM+tJxRb0nXg2/1xWx9uQmbsQvem2/rZXV2IjMoD/tj4Aqtiplz3pkk4aR6lU3DeX8dtUe9h0dBp7rArDZVIOGdFLW8/vvjr1wLD8u2mvFkt311vssXzKjWgKH/NfopNR5JxPFLOZuFY4x1/w730EofZlrDXvXu3rEWJJVPH+QZ/nQ0kICUkDrvqLvgb6qXnRA+M9+yRt2blu48cbrD4Q3PDLhqECg3Q+V7Q4/QdG4ic1jcm5GxsVbR1r6HYslIG//oJ5u7QmoBKu6FuxKNztfa/FbcKASeuH2ecT3qacBxQGNgUp8lznuYxhjIeS32+QRTOMKIXniLcGodp7+bH83nNxwYUpQ57IIglWg7jk4aTBWxhb+/9wFcen4O76OPml6uJH5WI2s/FvUzp2gXqE3KzOrLteKJ4xBwh6Wm/CD6xN5kEQqPEaFlDQs6uznw7H3UWQdLyuZ/IAq3RgqSeAiqgsv5OstRM3lPWlZeqGSxOm8fqHNgBYGxXhr6uM+JNCsemMYagz/8et11W46EODIDVahU+M12bT8Q3iJwGqTGXCYyB9sGprENS3g01MV4brNqgqKI0/b9wLnYSVnNgiK84194EUH6zzLIxJbdcrfejOtUVe9z81b/e11yx2WZyRksVwpuu667nnZP4Lo0sf+tI2n+9O0DdrpjPZCfNo4IYf8WmMRZgwlfe7/3dIOx2xbqRy6+Q/wHfUFBNcg3G5QAAAABJRU5ErkJggg==">多租户框架构
              </div>
              <div class="_tag_1amn3_1"><img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAuCAYAAABEbmvDAAAAAXNSR0IArs4c6QAABYhJREFUWEftmGtMFFcUx/9nZvYBLAhat6BUIaVUqfiqbaytdQEt8VPV4gPdjfigGF8xadVUpNm2Sm1sbFpj22hSHwhRaaUN1mhqBbTRNLYq4CtVAfERJVUKuLDL7Nzb7BLAdReYBdQv7KfNzv/8z2/OPXvnziH0xudE6iQtxIzmuw4LZuUrvWFJPTY5YUkWOTsgcQohUL7d8F8axhU29tS3+2BFSw0BQoNV4XwVAWIrSDNwlUssA2/lFfUEzm+wmMMrQqoCaxdrgdUKEN5R8kCOX52CJrth0s5T3QFUBTa6aFroJSEwUcOF6Q7w6SIoSG0yEShnwD6Fs8OyKa8UBK4mlgaUWBIVyAZGkrtp6zmCdEwI0xEbXA/ESEC8CMQBENQYdqaRCbVahrOKgMsyqCqEo8bGeYOiERwhjAl2znTNdvEPJOfUkKF43ikZ9EZPk/ZWvENiia7+7ANTW9G+iqmtVKuur2J9FfO3Ar70RpIw/7nX8VrocKRf3Yk6sDbZM+mx4VIglkdOxYyIBIRp+0FhCpaUfYGcusvPBixGDMCqyKmYHfkOgqWWx+ztpntYe+l7/PjwmkdRn0rFAkBYE27CkugUhGlD2gCKa85g+T87cE1p8lrpJw6WEhKDj19KQ6xhaFtyhTN8V5GPD28d6rBVVYO57nr9oCkgIqy7fbTL3h8i6rEhaiZSBk+GQO0HEpuzCR9d2obttaWdeqgCm2aIhjV2AYYFR7vNdlQVYMWNgx0aW/oNx6fD0hGhH+ihue+oxZLyL1Foq+7yxlSB7X7RjNmRyR5meTePYGFFrsdvRtJgU/RMzIlM9qiSS1TddBeLyjbjpL2mSyiXQBWYaxkL4lbCNHCch+kvd4qQdnUnmsCRFBCBr+KWefRSq/j6w5uYU7YJ5XK9KijVYC5huKBF4ci1iO8X62H+271TKL5fiszYNARKAV6JK223kVqajfN+QPkF5hKPkIJxcEwWhgRGqLrzG413MKc0G+ea61TpHxW1LaW+xPw750jsymGi3oj9o7PQXxfaqdTV6DPOWfGn40FXlj6vOyBMgGnPaRJL5v0scXpXjcv04Cj8MDITAZLep9yuNGNB6UYUNFSosfMNxikeCTkXSFNi3ipwLFfrlBE2GltGrIIotL3jukM551h7cSu+uX9GrZWXTgbnTI9QjM+tJxRb0nXg2/1xWx9uQmbsQvem2/rZXV2IjMoD/tj4Aqtiplz3pkk4aR6lU3DeX8dtUe9h0dBp7rArDZVIOGdFLW8/vvjr1wLD8u2mvFkt311vssXzKjWgKH/NfopNR5JxPFLOZuFY4x1/w730EofZlrDXvXu3rEWJJVPH+QZ/nQ0kICUkDrvqLvgb6qXnRA+M9+yRt2blu48cbrD4Q3PDLhqECg3Q+V7Q4/QdG4ic1jcm5GxsVbR1r6HYslIG//oJ5u7QmoBKu6FuxKNztfa/FbcKASeuH2ecT3qacBxQGNgUp8lznuYxhjIeS32+QRTOMKIXniLcGodp7+bH83nNxwYUpQ57IIglWg7jk4aTBWxhb+/9wFcen4O76OPml6uJH5WI2s/FvUzp2gXqE3KzOrLteKJ4xBwh6Wm/CD6xN5kEQqPEaFlDQs6uznw7H3UWQdLyuZ/IAq3RgqSeAiqgsv5OstRM3lPWlZeqGSxOm8fqHNgBYGxXhr6uM+JNCsemMYagz/8et11W46EODIDVahU+M12bT8Q3iJwGqTGXCYyB9sGprENS3g01MV4brNqgqKI0/b9wLnYSVnNgiK84194EUH6zzLIxJbdcrfejOtUVe9z81b/e11yx2WZyRksVwpuu667nnZP4Lo0sf+tI2n+9O0DdrpjPZCfNo4IYf8WmMRZgwlfe7/3dIOx2xbqRy6+Q/wHfUFBNcg3G5QAAAABJRU5ErkJggg==">丰富协议
              </div>
            </div>
          </div>
          <div class="_icon_1v56m_45">
            <div class="_bg_1v56m_59"></div><img class="_iconImage_1v56m_54" src="./assets/vico/icon3.12cf7904.png">
          </div>
        </div>
      </div>
      <div class="_slogan_1liym_1">
        <div class="_container_1liym_7">
          <div class="_title_1liym_25">全球布局、性能强大、安全、稳定的混合云</div>
          <div class="_desc_1liym_31">打造多云架构，统的操作管理，提供健壮、灵活安全、稳定的服务。让全球跨地域畅通无阻，体验顺畅</div>
          <div class="_tags_1liym_41">
            <div class="_tag_1amn3_1"><img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAuCAYAAABEbmvDAAAAAXNSR0IArs4c6QAABYhJREFUWEftmGtMFFcUx/9nZvYBLAhat6BUIaVUqfiqbaytdQEt8VPV4gPdjfigGF8xadVUpNm2Sm1sbFpj22hSHwhRaaUN1mhqBbTRNLYq4CtVAfERJVUKuLDL7Nzb7BLAdReYBdQv7KfNzv/8z2/OPXvnziH0xudE6iQtxIzmuw4LZuUrvWFJPTY5YUkWOTsgcQohUL7d8F8axhU29tS3+2BFSw0BQoNV4XwVAWIrSDNwlUssA2/lFfUEzm+wmMMrQqoCaxdrgdUKEN5R8kCOX52CJrth0s5T3QFUBTa6aFroJSEwUcOF6Q7w6SIoSG0yEShnwD6Fs8OyKa8UBK4mlgaUWBIVyAZGkrtp6zmCdEwI0xEbXA/ESEC8CMQBENQYdqaRCbVahrOKgMsyqCqEo8bGeYOiERwhjAl2znTNdvEPJOfUkKF43ikZ9EZPk/ZWvENiia7+7ANTW9G+iqmtVKuur2J9FfO3Ar70RpIw/7nX8VrocKRf3Yk6sDbZM+mx4VIglkdOxYyIBIRp+0FhCpaUfYGcusvPBixGDMCqyKmYHfkOgqWWx+ztpntYe+l7/PjwmkdRn0rFAkBYE27CkugUhGlD2gCKa85g+T87cE1p8lrpJw6WEhKDj19KQ6xhaFtyhTN8V5GPD28d6rBVVYO57nr9oCkgIqy7fbTL3h8i6rEhaiZSBk+GQO0HEpuzCR9d2obttaWdeqgCm2aIhjV2AYYFR7vNdlQVYMWNgx0aW/oNx6fD0hGhH+ihue+oxZLyL1Foq+7yxlSB7X7RjNmRyR5meTePYGFFrsdvRtJgU/RMzIlM9qiSS1TddBeLyjbjpL2mSyiXQBWYaxkL4lbCNHCch+kvd4qQdnUnmsCRFBCBr+KWefRSq/j6w5uYU7YJ5XK9KijVYC5huKBF4ci1iO8X62H+271TKL5fiszYNARKAV6JK223kVqajfN+QPkF5hKPkIJxcEwWhgRGqLrzG413MKc0G+ea61TpHxW1LaW+xPw750jsymGi3oj9o7PQXxfaqdTV6DPOWfGn40FXlj6vOyBMgGnPaRJL5v0scXpXjcv04Cj8MDITAZLep9yuNGNB6UYUNFSosfMNxikeCTkXSFNi3ipwLFfrlBE2GltGrIIotL3jukM551h7cSu+uX9GrZWXTgbnTI9QjM+tJxRb0nXg2/1xWx9uQmbsQvem2/rZXV2IjMoD/tj4Aqtiplz3pkk4aR6lU3DeX8dtUe9h0dBp7rArDZVIOGdFLW8/vvjr1wLD8u2mvFkt311vssXzKjWgKH/NfopNR5JxPFLOZuFY4x1/w730EofZlrDXvXu3rEWJJVPH+QZ/nQ0kICUkDrvqLvgb6qXnRA+M9+yRt2blu48cbrD4Q3PDLhqECg3Q+V7Q4/QdG4ic1jcm5GxsVbR1r6HYslIG//oJ5u7QmoBKu6FuxKNztfa/FbcKASeuH2ecT3qacBxQGNgUp8lznuYxhjIeS32+QRTOMKIXniLcGodp7+bH83nNxwYUpQ57IIglWg7jk4aTBWxhb+/9wFcen4O76OPml6uJH5WI2s/FvUzp2gXqE3KzOrLteKJ4xBwh6Wm/CD6xN5kEQqPEaFlDQs6uznw7H3UWQdLyuZ/IAq3RgqSeAiqgsv5OstRM3lPWlZeqGSxOm8fqHNgBYGxXhr6uM+JNCsemMYagz/8et11W46EODIDVahU+M12bT8Q3iJwGqTGXCYyB9sGprENS3g01MV4brNqgqKI0/b9wLnYSVnNgiK84194EUH6zzLIxJbdcrfejOtUVe9z81b/e11yx2WZyRksVwpuu667nnZP4Lo0sf+tI2n+9O0DdrpjPZCfNo4IYf8WmMRZgwlfe7/3dIOx2xbqRy6+Q/wHfUFBNcg3G5QAAAABJRU5ErkJggg==">标准组件化
            </div>
            <div class="_tag_1amn3_1"><img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAuCAYAAABEbmvDAAAAAXNSR0IArs4c6QAABYhJREFUWEftmGtMFFcUx/9nZvYBLAhat6BUIaVUqfiqbaytdQEt8VPV4gPdjfigGF8xadVUpNm2Sm1sbFpj22hSHwhRaaUN1mhqBbTRNLYq4CtVAfERJVUKuLDL7Nzb7BLAdReYBdQv7KfNzv/8z2/OPXvnziH0xudE6iQtxIzmuw4LZuUrvWFJPTY5YUkWOTsgcQohUL7d8F8axhU29tS3+2BFSw0BQoNV4XwVAWIrSDNwlUssA2/lFfUEzm+wmMMrQqoCaxdrgdUKEN5R8kCOX52CJrth0s5T3QFUBTa6aFroJSEwUcOF6Q7w6SIoSG0yEShnwD6Fs8OyKa8UBK4mlgaUWBIVyAZGkrtp6zmCdEwI0xEbXA/ESEC8CMQBENQYdqaRCbVahrOKgMsyqCqEo8bGeYOiERwhjAl2znTNdvEPJOfUkKF43ikZ9EZPk/ZWvENiia7+7ANTW9G+iqmtVKuur2J9FfO3Ar70RpIw/7nX8VrocKRf3Yk6sDbZM+mx4VIglkdOxYyIBIRp+0FhCpaUfYGcusvPBixGDMCqyKmYHfkOgqWWx+ztpntYe+l7/PjwmkdRn0rFAkBYE27CkugUhGlD2gCKa85g+T87cE1p8lrpJw6WEhKDj19KQ6xhaFtyhTN8V5GPD28d6rBVVYO57nr9oCkgIqy7fbTL3h8i6rEhaiZSBk+GQO0HEpuzCR9d2obttaWdeqgCm2aIhjV2AYYFR7vNdlQVYMWNgx0aW/oNx6fD0hGhH+ihue+oxZLyL1Foq+7yxlSB7X7RjNmRyR5meTePYGFFrsdvRtJgU/RMzIlM9qiSS1TddBeLyjbjpL2mSyiXQBWYaxkL4lbCNHCch+kvd4qQdnUnmsCRFBCBr+KWefRSq/j6w5uYU7YJ5XK9KijVYC5huKBF4ci1iO8X62H+271TKL5fiszYNARKAV6JK223kVqajfN+QPkF5hKPkIJxcEwWhgRGqLrzG413MKc0G+ea61TpHxW1LaW+xPw750jsymGi3oj9o7PQXxfaqdTV6DPOWfGn40FXlj6vOyBMgGnPaRJL5v0scXpXjcv04Cj8MDITAZLep9yuNGNB6UYUNFSosfMNxikeCTkXSFNi3ipwLFfrlBE2GltGrIIotL3jukM551h7cSu+uX9GrZWXTgbnTI9QjM+tJxRb0nXg2/1xWx9uQmbsQvem2/rZXV2IjMoD/tj4Aqtiplz3pkk4aR6lU3DeX8dtUe9h0dBp7rArDZVIOGdFLW8/vvjr1wLD8u2mvFkt311vssXzKjWgKH/NfopNR5JxPFLOZuFY4x1/w730EofZlrDXvXu3rEWJJVPH+QZ/nQ0kICUkDrvqLvgb6qXnRA+M9+yRt2blu48cbrD4Q3PDLhqECg3Q+V7Q4/QdG4ic1jcm5GxsVbR1r6HYslIG//oJ5u7QmoBKu6FuxKNztfa/FbcKASeuH2ecT3qacBxQGNgUp8lznuYxhjIeS32+QRTOMKIXniLcGodp7+bH83nNxwYUpQ57IIglWg7jk4aTBWxhb+/9wFcen4O76OPml6uJH5WI2s/FvUzp2gXqE3KzOrLteKJ4xBwh6Wm/CD6xN5kEQqPEaFlDQs6uznw7H3UWQdLyuZ/IAq3RgqSeAiqgsv5OstRM3lPWlZeqGSxOm8fqHNgBYGxXhr6uM+JNCsemMYagz/8et11W46EODIDVahU+M12bT8Q3iJwGqTGXCYyB9sGprENS3g01MV4brNqgqKI0/b9wLnYSVnNgiK84194EUH6zzLIxJbdcrfejOtUVe9z81b/e11yx2WZyRksVwpuu667nnZP4Lo0sf+tI2n+9O0DdrpjPZCfNo4IYf8WmMRZgwlfe7/3dIOx2xbqRy6+Q/wHfUFBNcg3G5QAAAABJRU5ErkJggg==">云配置
            </div>
            <div class="_tag_1amn3_1"><img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAuCAYAAABEbmvDAAAAAXNSR0IArs4c6QAABYhJREFUWEftmGtMFFcUx/9nZvYBLAhat6BUIaVUqfiqbaytdQEt8VPV4gPdjfigGF8xadVUpNm2Sm1sbFpj22hSHwhRaaUN1mhqBbTRNLYq4CtVAfERJVUKuLDL7Nzb7BLAdReYBdQv7KfNzv/8z2/OPXvnziH0xudE6iQtxIzmuw4LZuUrvWFJPTY5YUkWOTsgcQohUL7d8F8axhU29tS3+2BFSw0BQoNV4XwVAWIrSDNwlUssA2/lFfUEzm+wmMMrQqoCaxdrgdUKEN5R8kCOX52CJrth0s5T3QFUBTa6aFroJSEwUcOF6Q7w6SIoSG0yEShnwD6Fs8OyKa8UBK4mlgaUWBIVyAZGkrtp6zmCdEwI0xEbXA/ESEC8CMQBENQYdqaRCbVahrOKgMsyqCqEo8bGeYOiERwhjAl2znTNdvEPJOfUkKF43ikZ9EZPk/ZWvENiia7+7ANTW9G+iqmtVKuur2J9FfO3Ar70RpIw/7nX8VrocKRf3Yk6sDbZM+mx4VIglkdOxYyIBIRp+0FhCpaUfYGcusvPBixGDMCqyKmYHfkOgqWWx+ztpntYe+l7/PjwmkdRn0rFAkBYE27CkugUhGlD2gCKa85g+T87cE1p8lrpJw6WEhKDj19KQ6xhaFtyhTN8V5GPD28d6rBVVYO57nr9oCkgIqy7fbTL3h8i6rEhaiZSBk+GQO0HEpuzCR9d2obttaWdeqgCm2aIhjV2AYYFR7vNdlQVYMWNgx0aW/oNx6fD0hGhH+ihue+oxZLyL1Foq+7yxlSB7X7RjNmRyR5meTePYGFFrsdvRtJgU/RMzIlM9qiSS1TddBeLyjbjpL2mSyiXQBWYaxkL4lbCNHCch+kvd4qQdnUnmsCRFBCBr+KWefRSq/j6w5uYU7YJ5XK9KijVYC5huKBF4ci1iO8X62H+271TKL5fiszYNARKAV6JK223kVqajfN+QPkF5hKPkIJxcEwWhgRGqLrzG413MKc0G+ea61TpHxW1LaW+xPw750jsymGi3oj9o7PQXxfaqdTV6DPOWfGn40FXlj6vOyBMgGnPaRJL5v0scXpXjcv04Cj8MDITAZLep9yuNGNB6UYUNFSosfMNxikeCTkXSFNi3ipwLFfrlBE2GltGrIIotL3jukM551h7cSu+uX9GrZWXTgbnTI9QjM+tJxRb0nXg2/1xWx9uQmbsQvem2/rZXV2IjMoD/tj4Aqtiplz3pkk4aR6lU3DeX8dtUe9h0dBp7rArDZVIOGdFLW8/vvjr1wLD8u2mvFkt311vssXzKjWgKH/NfopNR5JxPFLOZuFY4x1/w730EofZlrDXvXu3rEWJJVPH+QZ/nQ0kICUkDrvqLvgb6qXnRA+M9+yRt2blu48cbrD4Q3PDLhqECg3Q+V7Q4/QdG4ic1jcm5GxsVbR1r6HYslIG//oJ5u7QmoBKu6FuxKNztfa/FbcKASeuH2ecT3qacBxQGNgUp8lznuYxhjIeS32+QRTOMKIXniLcGodp7+bH83nNxwYUpQ57IIglWg7jk4aTBWxhb+/9wFcen4O76OPml6uJH5WI2s/FvUzp2gXqE3KzOrLteKJ4xBwh6Wm/CD6xN5kEQqPEaFlDQs6uznw7H3UWQdLyuZ/IAq3RgqSeAiqgsv5OstRM3lPWlZeqGSxOm8fqHNgBYGxXhr6uM+JNCsemMYagz/8et11W46EODIDVahU+M12bT8Q3iJwGqTGXCYyB9sGprENS3g01MV4brNqgqKI0/b9wLnYSVnNgiK84194EUH6zzLIxJbdcrfejOtUVe9z81b/e11yx2WZyRksVwpuu667nnZP4Lo0sf+tI2n+9O0DdrpjPZCfNo4IYf8WmMRZgwlfe7/3dIOx2xbqRy6+Q/wHfUFBNcg3G5QAAAABJRU5ErkJggg==">移动分析
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
:root {
  --vc-width: 1400px;
  --vc-nav-height: 64px;
  --vc-padding: 20px;
  --vc-container-padding: 10px;
  --vc-font-size: 14px;
  --vc-font-size-large: 42px;
  --vc-font-size-big: 30px;
  --vc-font-size-bold: 24px;
  --vc-font-size-bold-1: 22px;
  --vc-font-size-bold-2: 20px;
  --vc-font-size-bold-3: 18px;
  --vc-font-size-bold-4: 16px;
  --vc-font-size-small: 12px;
  --vc-font-weight-bold: 500;
  --vc-font-family: PingFang SC, SF Pro, Microsoft YaHei, Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Hiragino Sans GB, Helvetica Neue, Helvetica, sans-serif;
  --vc-color-white: #fff;
  --vc-bg: #fff;
  --vc-block-bg: #f7f8fa;
  --vc-color-box-shadow: rgba(61, 61, 61, .15);
  --vc-box-shadow-color: var(--vc-color-box-shadow);
  --vc-color-primary: #295dfa;
  --vc-primary-color: var(--vc-color-primary);
  --vc-color-primary-light-1: #3e6dfb;
  --vc-primary-color-light-1: var(--vc-color-primary-light-1);
  --vc-color-primary-light-2: #547dfb;
  --vc-primary-color-light-2: var(--vc-color-primary-light-2);
  --vc-color-primary-light-3: #698efc;
  --vc-primary-color-light-3: var(--vc-color-primary-light-3);
  --vc-color-primary-light-4: #7f9efc;
  --vc-primary-color-light-4: var(--vc-color-primary-light-4);
  --vc-color-primary-light-5: #94aefd;
  --vc-primary-color-light-5: var(--vc-color-primary-light-5);
  --vc-color-primary-light-6: #a9befd;
  --vc-primary-color-light-6: var(--vc-color-primary-light-6);
  --vc-color-primary-light-7: #bfcefe;
  --vc-primary-color-light-7: var(--vc-color-primary-light-7);
  --vc-color-primary-light-8: #d4dffe;
  --vc-primary-color-light-8: var(--vc-color-primary-light-8);
  --vc-color-primary-light-9: #eaefff;
  --vc-primary-color-light-9: var(--vc-color-primary-light-9);
  --vc-color-primary-hover: #053eeb;
  --vc-primary-hover-color: var(--vc-color-primary-hover);
  --vc-color-secondary-light: #f1f3f5;
  --vc-color-secondary-dark: #c6ced6;
  --vc-color-table-normal: var(--vc-color-white);
  --vc-color-table-hover: var(--vc-color-secondary-light);
  --vc-color-table-active: var(--vc-color-secondary-dark);
  --vc-color-menu-normal: var(--vc-color-white);
  --vc-color-menu-hover: linear-gradient(90deg, rgba(41, 93, 250, .06) .21%, rgba(255, 255, 255, .2) 99.79%);
  --vc-color-menu-active: var(--vc-color-menu-hover);
  --vc-color-error: #fb4338;
  --vc-color-warning: #ffaa00;
  --vc-color-success: #3cc151;
  --vc-color-info: #295dfa;
  --vc-color-disabled: rgba(0, 0, 0, .3);
  --vc-color-text: #000;
  --vc-text-color: var(--vc-color-text);
  --vc-color-text-dark-1: rgba(0, 0, 0, .1);
  --vc-color-text-dark-2: rgba(0, 0, 0, .2);
  --vc-color-text-dark-3: rgba(0, 0, 0, .3);
  --vc-color-text-dark-4: rgba(0, 0, 0, .4);
  --vc-color-text-dark-5: rgba(0, 0, 0, .5);
  --vc-color-text-dark-6: rgba(0, 0, 0, .6);
  --vc-color-text-dark-7: rgba(0, 0, 0, .7);
  --vc-color-text-dark-8: rgba(0, 0, 0, .8);
  --vc-color-text-dark-9: rgba(0, 0, 0, .9);
  --vc-color-text-light: #fff;
  --vc-color-text-light-1: rgba(#fff, .6);
  --vc-color-text-light-2: rgba(#fff, .9);
  --vc-color-text-primary: var(--vc-color-primary);
  --vc-color-text-primary-light: rgba(#295dfa, .9);
  --vc-menu-width: 240px;
  --vc-button-info-hover-bg-color: rgba(0, 0, 0, .12);
  --vc-button-info-active-bg-color: rgba(0, 0, 0, .16);
  --vc-button-primary-hover-bg-color: linear-gradient(0deg, rgba(255, 255, 255, .2), rgba(255, 255, 255, .2)), #295DFA;
  --vc-button-primary-active-bg-color: linear-gradient(0deg, rgba(0, 0, 0, .2), rgba(0, 0, 0, .2)), #295DFA;
  --vc-button-warning-hover-bg-color: linear-gradient(0deg, rgba(255, 255, 255, .2), rgba(255, 255, 255, .2)), #FFAA00;
  --vc-button-warning-active-bg-color: linear-gradient(0deg, rgba(0, 0, 0, .2), rgba(0, 0, 0, .2)), #FFAA00;
  --vc-button-error-hover-bg-color: linear-gradient(0deg, rgba(255, 255, 255, .2), rgba(255, 255, 255, .2)), #FB4338;
  --vc-button-error-active-bg-color: linear-gradient(0deg, rgba(0, 0, 0, .2), rgba(0, 0, 0, .2)), #FB4338;
  --vc-button-disabled-bg-color: rgba(0, 0, 0, .06);
  --vc-table-border-color: #e1e1e1;
  --vc-table-row-bg-color: #F5F7FA;
  --vc-table-header-bg-color: rgba(198, 206, 214, .4);
  --vc-table-header-fix-color: rgb(198, 206, 214);
  --vc-table-operate-danger-color: #E53F10;
  --vc-disabled-bg-color: rgba(0, 0, 0, .04);
  --vc-inline-form-item-margin: 12px;
  --vc-tag-margin-left: 8px
}

html {
  font-family: var(--vc-font-family)
}

html,
body,
p,
h1,
h2,
h3,
h4,
h5,
h6,
ul,
li {
  margin: 0;
  padding: 0
}

ul {
  list-style: none
}

.voiceCloudContainer {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  height: var(--vc-nav-height);
  padding: 0 var(--vc-padding);
  font-size: var(--vc-font-size);
  background: var(--vc-bg);
  z-index: 1000;
  font-family: var(--vc-font-family);
  box-shadow: 0 2px 3px var(--vc-box-shadow-color)
}

:root,
html,
body {
  --el-color-primary: var(--vc-color-primary);
  --el-disabled-bg-color: var(--vc-disabled-bg-color);
  --el-disabled-border-color: var(--vc-color-text-dark-1);
  --el-text-color-placeholder: var(--vc-color-text-dark-2);
  --el-menu-active-color: var(--vc-color-primary);
  --el-color-primary-light-1: var(--vc-color-primary-light-1);
  --el-color-primary-light-2: var(--vc-color-primary-light-2);
  --el-color-primary-light-3: var(--vc-color-primary-light-3);
  --el-color-primary-light-4: var(--vc-color-primary-light-4);
  --el-color-primary-light-5: var(--vc-color-primary-light-5);
  --el-color-primary-light-6: var(--vc-color-primary-light-6);
  --el-color-primary-light-7: var(--vc-color-primary-light-7);
  --el-color-primary-light-8: var(--vc-color-primary-light-8);
  --el-color-primary-light-9: var(--vc-color-primary-light-9)
}

body .el-menu {
  width: var(--vc-menu-width);
  border: none
}

body .el-menu[role=menubar]>.el-menu-item {
  font-weight: 600;
  color: var(--vc-color-text-dark-9)
}

body .el-menu[role=menubar]>.el-menu-item:hover {
  color: var(--vc-color-primary)
}

body .el-menu-item:hover {
  background: var(--vc-color-menu-hover);
  color: var(--vc-color-primary)
}

body .el-sub-menu__title {
  font-weight: 600;
  color: var(--vc-color-text-dark-9)
}

body .el-sub-menu__title:hover {
  background: var(--vc-color-menu-hover);
  color: var(--vc-color-primary)
}

body .el-sub-menu__title:hover i {
  color: var(--vc-color-primary)
}

body .el-button--info {
  --el-button-bg-color: var(--vc-color-text-dark-1);
  --el-button-border-color: var(--vc-color-text-dark-1);
  color: var(--vc-color-text-dark-5);
  border: none
}

body .el-button--info:hover,
body .el-button--info :focus {
  background: var(--vc-button-info-hover-bg-color);
  color: var(--vc-color-text-dark-5)
}

body .el-button--info:active {
  background: var(--vc-button-info-active-bg-color);
  color: var(--vc-color-text-dark-5)
}

body .el-button--primary {
  --el-button-bg-color: var(--vc-color-primary);
  --el-button-border-color: var(--vc-color-primary)
}

body .el-button--primary:hover,
body .el-button--primary :focus {
  background: var(--vc-button-primary-hover-bg-color)
}

body .el-button--primary:active {
  background: var(--vc-button-primary-active-bg-color)
}

body .el-button--warning {
  --el-button-bg-color: var(--vc-color-warning);
  --el-button-border-color: var(--vc-color-warning)
}

body .el-button--warning:hover,
body .el-button--warning :focus {
  background: var(--vc-button-warning-hover-bg-color)
}

body .el-button--warning:active {
  background: var(--vc-button-warning-active-bg-color)
}

body .el-button--danger {
  --el-button-bg-color: var(--vc-color-error);
  --el-button-border-color: var(--vc-color-error)
}

body .el-button--danger:hover,
body .el-button--danger :focus {
  background: var(--vc-button-error-hover-bg-color)
}

body .el-button--danger:active {
  background: var(--vc-button-error-active-bg-color)
}

body .el-button.is-disabled,
body .el-button.is-disabled:hover {
  color: var(--vc-color-text-dark-2);
  background-color: var(--vc-button-disabled-bg-color);
  border: none
}

body .el-button.is-text {
  padding: 0
}

body .el-card {
  border: none;
  border-radius: 0
}

body .el-card__header {
  font-size: 18px;
  font-weight: 700;
  color: var(--vc-color-text-dark-9)
}

body .el-main {
  --el-main-padding: 10px
}

body .el-table {
  --el-table-border-color: var(--vc-table-border-color);
  --el-table-row-hover-bg-color: var(--vc-table-row-bg-color);
  --el-table-current-row-bg-color: var(--vc-table-row-bg-color);
  --el-table-text-color: var(--vc-color-text-dark-6);
  --el-table-header-bg-color: var(--vc-table-header-bg-color)
}

body .el-table__header th.el-table__cell {
  background-color: var(--vc-table-header-bg-color);
  line-height: 31px
}

body .el-table__header th.el-table__cell>.cell {
  color: var(--vc-color-text)
}

body .el-table__header-wrapper tr th.el-table-fixed-column--left,
body .el-table__header-wrapper tr th.el-table-fixed-column--right {
  background-color: var(--vc-table-header-fix-color)
}

body .el-input {
  --el-input-border-color: rgba(0, 0, 0, .3);
  --el-input-hover-border: rgba(0, 0, 0, .7)
}

body .el-form--inline .el-form-item {
  margin-right: var(--vc-inline-form-item-margin)
}

body .el-tag:not(:first-child) {
  margin-left: var(--vc-tag-margin-left)
}

body .el-transfer {
  --el-transfer-panel-header-bg-color: var(--vc-table-header-bg-color)
}

body .el-message-box__status.el-icon {
  position: absolute
}

p {
  margin: 0;
  padding: 0
}

html {
  line-height: 1.15;
  -webkit-text-size-adjust: 100%
}

body {
  margin: 0
}

main {
  display: block
}

h1 {
  font-size: 2em;
  margin: .67em 0
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible
}

pre {
  font-family: monospace, monospace;
  font-size: 1em
}

a {
  background-color: transparent
}

abbr[title] {
  border-bottom: none;
  text-decoration: underline;
  text-decoration: underline dotted
}

b,
strong {
  font-weight: bolder
}

code,
kbd,
samp {
  font-family: monospace, monospace;
  font-size: 1em
}

small {
  font-size: 80%
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline
}

sub {
  bottom: -.25em
}

sup {
  top: -.5em
}

img {
  border-style: none
}

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0
}

button,
input {
  overflow: visible
}

button,
select {
  text-transform: none
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0
}

button:-moz-focusring,
[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText
}

fieldset {
  padding: .35em .75em .625em
}

legend {
  box-sizing: border-box;
  color: inherit;
  display: table;
  max-width: 100%;
  padding: 0;
  white-space: normal
}

progress {
  vertical-align: baseline
}

textarea {
  overflow: auto
}

[type=checkbox],
[type=radio] {
  box-sizing: border-box;
  padding: 0
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit
}

details {
  display: block
}

summary {
  display: list-item
}

template {
  display: none
}

[hidden] {
  display: none
}

:root {
  --bg: #f7f8fa;
  --font-size-sm: 12px;
  --font-size-base: 14px;
  --font-size-ml: 18px;
  --font-size-lg: 24px;
  --font-size-text: 22px;
  --font-size-title: 30px;
  --base-margin: 40px
}

body {
  min-width: var(--vc-width);
  font-family: var(--vc-family);
  background: var(--bg)
}

._container_1o1yz_18 {
  /* padding-top: 64px */
}

.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -khtml-user-select: none;
  -ms-touch-action: pan-y;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent
}

.slick-list {
  position: relative;
  display: block;
  overflow: hidden;
  margin: 0;
  padding: 0
}

.slick-list:focus {
  outline: none
}

.slick-list.dragging {
  cursor: pointer;
  cursor: hand
}

.slick-slider .slick-track,
.slick-slider .slick-list {
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
  transform: translate(0)
}

.slick-track {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  margin-left: auto;
  margin-right: auto
}

.slick-track:before,
.slick-track:after {
  display: table;
  content: ""
}

.slick-track:after {
  clear: both
}

.slick-loading .slick-track {
  visibility: hidden
}

.slick-slide {
  display: none;
  float: left;
  height: 100%;
  min-height: 1px
}

[dir=rtl] .slick-slide {
  float: right
}

.slick-slide img {
  display: block
}

.slick-slide.slick-loading img {
  display: none
}

.slick-slide.dragging img {
  pointer-events: none
}

.slick-initialized .slick-slide {
  display: block
}

.slick-loading .slick-slide {
  visibility: hidden
}

.slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent
}

.slick-arrow.slick-hidden {
  display: none
}

.slick-loading .slick-list {
  background: #fff url(./assets/vico/ajax-loader.e7b44c86.gif) center center no-repeat
}

@font-face {
  font-family: "slick";
  font-weight: normal;
  font-style: normal;
  src: url(data:null;base64,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);
  src: url(data:null;base64,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) format("embedded-opentype"), url(data:font/woff;base64,d09GRk9UVE8AAAVkAAsAAAAAB1wAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAABCAAAAi4AAAKbH/pWDkZGVE0AAAM4AAAAGgAAABxt0civR0RFRgAAA1QAAAAcAAAAIAAyAARPUy8yAAADcAAAAFIAAABgUBj/rmNtYXAAAAPEAAAAUAAAAWIiC0SwaGVhZAAABBQAAAAuAAAANgABMftoaGVhAAAERAAAABwAAAAkA+UCA2htdHgAAARgAAAADgAAAA4ESgBKbWF4cAAABHAAAAAGAAAABgAFUABuYW1lAAAEeAAAANwAAAFuBSeBwnBvc3QAAAVUAAAAEAAAACAAAwABeJw9ks9vEkEUx2cpWyeUoFYgNkHi2Wt7N3rVm3cTs3UVLC4LxIWEQvi1P3i7O1tYLJDAmlgKGEhQrsajf0j7J3jYTXrQWUrMJG+++b55n5e8NwwKBhHDMLv5kxT3ATEBxKBn3qOAl9zxHgb1MAPhHQgHkyF08Gr/L8B/Eb6zWnmCJ7AJVLubQOheArXvJ1A4EXi6j4I+Zg9F0QFKvsnlBCmXeve+sFEnb/nCptdtQ4QYhVFRAT1HrF8UQK/RL/SbmUbclsvGVFXRZKDHUE38cc4qpkbAAsuwiImvro+ufcfaOIQ6szlrmjRJDaKZKnbjN3GWKIbiIzRFUfCffuxxKOL+3LDlDVvx2TdxN84qZEsnhNBa6pgm2dAsnzbLsETdsmRFxUeHV4e+I2/ptN8TyqV8T3Dt29t7EYOuajVIw2y1Wy3M86w0zg/Fz2IvawmQAUHOVrPVfLkoScVynsqsTG0MGUs4z55nh3mnOJa+li+rl9WpPIcFfDubDeaDC+fLBdYN3QADzLauGfj4B6sZmq6CCpqmtSvF0qlUl2qf5AJIUCSlTqlb7lUG+LRfGzZGzZEyBgccMu6MuqPecNDvD4Y9Kjtj4gD+DsvKVMTcMdtqtZtmkzQstQvYje7Syep0PDSAhSOeHYXYWThEF//A/0YvYV1fSQtpKU5STtrhbQ444OtpKSWJIg3pOg8cBs7maTY1EZf07aq+hjWs7IWzdCYTGhb2CtZ47x+Uhx28AAB4nGNgYGBkAIJz765vANHnCyvqYTQAWnkHswAAeJxjYGRgYOADYgkGEGBiYARCFjAG8RgABHYAN3icY2BmYmCcwMDKwMHow5jGwMDgDqW/MkgytDAwMDGwcjKAQQMDAyOQUmCAgoA01xQGB4ZExUmMD/4/YNBjvP3/NgNEDQPjbbBKBQZGADfLDgsAAHicY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQzMCQqKClOUJz0/z9YHRLv/+L7D+8V3cuHmgAHjGwM6ELUByxUMIOZCmbgAAA5LQ8XeJxjYGRgYABiO68w73h+m68M3EwMIHC+sKIeTqsyqDLeZrwN5HIwgKUB/aYJUgAAeJxjYGRgYLzNwMCgx8QAAkA2IwMqYAIAMGIB7QIAAAACAAAlACUAJQAlAAAAAFAAAAUAAHicbY49asNAEIU/2ZJDfkiRIvXapUFCEqpcptABUrg3ZhEiQoKVfY9UqVLlGDlADpAT5e16IUWysMz3hjfzBrjjjQT/EjKpCy+4YhN5yZoxcirPe+SMWz4jr6S+5UzSa3VuwpTnBfc8RF7yxDZyKs9r5IxHPiKv1P9iZqDnyAvMQ39UecbScVb/gJO03Xk4CFom3XYK1clhMdQUlKo7/d9NF13RkIdfy+MV7TSe2sl11tRFaXYmJKpWTd7kdVnJ8veevZKc+n3I93t9Jnvr5n4aTVWU/0z9AI2qMkV4nGNgZkAGjAxoAAAAjgAF) format("woff"), url(data:font/ttf;base64,AAEAAAANAIAAAwBQRkZUTW3RyK8AAAdIAAAAHEdERUYANAAGAAAHKAAAACBPUy8yT/b9sgAAAVgAAABWY21hcCIPRb0AAAHIAAABYmdhc3D//wADAAAHIAAAAAhnbHlmP5u2YAAAAzwAAAIsaGVhZAABMfsAAADcAAAANmhoZWED5QIFAAABFAAAACRobXR4BkoASgAAAbAAAAAWbG9jYQD2AaIAAAMsAAAAEG1heHAASwBHAAABOAAAACBuYW1lBSeBwgAABWgAAAFucG9zdC+zMgMAAAbYAAAARQABAAAAAQAA8MQQT18PPPUACwIAAAAAAM9xeH8AAAAAz3F4fwAlACUB2wHbAAAACAACAAAAAAAAAAEAAAHbAAAALgIAAAAAAAHbAAEAAAAAAAAAAAAAAAAAAAAEAAEAAAAHAEQAAgAAAAAAAgAAAAEAAQAAAEAAAAAAAAAAAQIAAZAABQAIAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAIABQkAAAAAAACAAAABAAAAIAAAAAAAAAAAUGZFZABAAGEhkgHg/+AALgHb/9sAAAABAAAAAAAAAgAAAAAAAAACAAAAAgAAJQAlACUAJQAAAAAAAwAAAAMAAAAcAAEAAAAAAFwAAwABAAAAHAAEAEAAAAAMAAgAAgAEAAAAYSAiIZAhkv//AAAAAABhICIhkCGS//8AAP+l3+PedN5xAAEAAAAAAAAAAAAAAAAAAAEGAAABAAAAAAAAAAECAAAAAgAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGAIwAsAEWAAIAJQAlAdsB2wAYACwAAD8BNjQvASYjIg8BBhUUHwEHBhUUHwEWMzI2FAcGBwYiJyYnJjQ3Njc2MhcWF/GCBgaCBQcIBR0GBldXBgYdBQgH7x0eMjB8MDIeHR0eMjB8MDIecYIGDgaCBQUeBQcJBFhYBAkHBR4F0nwwMh4dHR4yMHwwMh4dHR4yAAAAAgAlACUB2wHbABgALAAAJTc2NTQvATc2NTQvASYjIg8BBhQfARYzMjYUBwYHBiInJicmNDc2NzYyFxYXASgdBgZXVwYGHQUIBwWCBgaCBQcIuB0eMjB8MDIeHR0eMjB8MDIecR4FBwkEWFgECQcFHgUFggYOBoIF0nwwMh4dHR4yMHwwMh4dHR4yAAABACUAJQHbAdsAEwAAABQHBgcGIicmJyY0NzY3NjIXFhcB2x0eMjB8MDIeHR0eMjB8MDIeAT58MDIeHR0eMjB8MDIeHR0eMgABACUAJQHbAdsAQwAAARUUBisBIicmPwEmIyIHBgcGBwYUFxYXFhcWMzI3Njc2MzIfARYVFAcGBwYjIicmJyYnJjQ3Njc2NzYzMhcWFzc2FxYB2woIgAsGBQkoKjodHBwSFAwLCwwUEhwcHSIeIBMGAQQDJwMCISspNC8mLBobFBERFBsaLCYvKicpHSUIDAsBt4AICgsLCScnCwwUEhwcOhwcEhQMCw8OHAMDJwMDAgQnFBQRFBsaLCZeJiwaGxQRDxEcJQgEBgAAAAAAAAwAlgABAAAAAAABAAUADAABAAAAAAACAAcAIgABAAAAAAADACEAbgABAAAAAAAEAAUAnAABAAAAAAAFAAsAugABAAAAAAAGAAUA0gADAAEECQABAAoAAAADAAEECQACAA4AEgADAAEECQADAEIAKgADAAEECQAEAAoAkAADAAEECQAFABYAogADAAEECQAGAAoAxgBzAGwAaQBjAGsAAHNsaWNrAABSAGUAZwB1AGwAYQByAABSZWd1bGFyAABGAG8AbgB0AEYAbwByAGcAZQAgADIALgAwACAAOgAgAHMAbABpAGMAawAgADoAIAAxADQALQA0AC0AMgAwADEANAAARm9udEZvcmdlIDIuMCA6IHNsaWNrIDogMTQtNC0yMDE0AABzAGwAaQBjAGsAAHNsaWNrAABWAGUAcgBzAGkAbwBuACAAMQAuADAAAFZlcnNpb24gMS4wAABzAGwAaQBjAGsAAHNsaWNrAAAAAAIAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAABwAAAAEAAgECAQMAhwBECmFycm93cmlnaHQJYXJyb3dsZWZ0AAAAAAAAAf//AAIAAQAAAA4AAAAYAAAAAAACAAEAAwAGAAEABAAAAAIAAAAAAAEAAAAAzu7XsAAAAADPcXh/AAAAAM9xeH8=) format("truetype"), url(./assets/vico/slick.12459f22.svg#slick) format("svg")
}

.slick-prev,
.slick-next {
  font-size: 0;
  line-height: 0;
  position: absolute;
  top: 50%;
  display: block;
  width: 20px;
  height: 20px;
  padding: 0;
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  transform: translateY(-50%);
  cursor: pointer;
  color: transparent;
  border: none;
  outline: none;
  background: transparent
}

.slick-prev:hover,
.slick-prev:focus,
.slick-next:hover,
.slick-next:focus {
  color: transparent;
  outline: none;
  background: transparent
}

.slick-prev:hover:before,
.slick-prev:focus:before,
.slick-next:hover:before,
.slick-next:focus:before {
  opacity: 1
}

.slick-prev.slick-disabled:before,
.slick-next.slick-disabled:before {
  opacity: .25
}

.slick-prev:before,
.slick-next:before {
  font-family: "slick";
  font-size: 20px;
  line-height: 1;
  opacity: .75;
  color: #fff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale
}

.slick-prev {
  left: -25px
}

[dir=rtl] .slick-prev {
  right: -25px;
  left: auto
}

.slick-prev:before {
  content: "\2190"
}

[dir=rtl] .slick-prev:before {
  content: "\2192"
}

.slick-next {
  right: -25px
}

[dir=rtl] .slick-next {
  right: auto;
  left: -25px
}

.slick-next:before {
  content: "\2192"
}

[dir=rtl] .slick-next:before {
  content: "\2190"
}

.slick-dotted.slick-slider {
  margin-bottom: 30px
}

.slick-dots {
  position: absolute;
  bottom: -25px;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center
}

.slick-dots li {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: 0 5px;
  padding: 0;
  cursor: pointer
}

.slick-dots li button {
  font-size: 0;
  line-height: 0;
  display: block;
  width: 20px;
  height: 20px;
  padding: 5px;
  cursor: pointer;
  color: transparent;
  border: 0;
  outline: none;
  background: transparent
}

.slick-dots li button:hover,
.slick-dots li button:focus {
  outline: none
}

.slick-dots li button:hover:before,
.slick-dots li button:focus:before {
  opacity: 1
}

.slick-dots li button:before {
  font-family: "slick";
  font-size: 6px;
  line-height: 20px;
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  content: "\2022";
  text-align: center;
  opacity: .25;
  color: #000;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale
}

.slick-dots li.slick-active button:before {
  opacity: .75;
  color: #000
}

._container_b8miy_1 .slick-dots {
  width: var(--vc-width);
  left: 50%;
  transform: translate(-50%);
  text-align: left;
  padding-left: 60px;
  bottom: 100px
}

._container_b8miy_1 .slick-dots li {
  width: 40px;
  height: 6px;
  margin: 0 10px 0 0;
  background: rgba(255, 255, 255, .5)
}

._container_b8miy_1 .slick-dots li.slick-active {
  background: #fff
}

._container_b8miy_1 .slick-dots li button:before {
  font-size: 0
}

._container_b8miy_1 {
  width: 100%;
  overflow: hidden
}

._sliderItem_b8miy_32 {
  position: relative;
  height: 500px;
  display: flex;
  justify-content: flex-end
}

._bg_b8miy_39 {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: -1
}

._content_b8miy_48 {
  display: flex;
  flex-direction: column;
  width: var(--vc-width);
  padding: 0 var(--vc-padding);
  margin: 0 auto;
  padding-left: 80px;
  padding-top: 145px
}

._slogan_b8miy_58 {
  max-width: 720px;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden
}

._title_b8miy_67 {
  font-weight: 700;
  font-size: 42px;
  color: var(--vc-text-color)
}

._slogan_b8miy_58 {
  font-size: 20px;
  margin-top: 20px;
  font-weight: 300
}

._buttonGroup_b8miy_79 {
  margin-top: var(--base-margin)
}

._button_b8miy_79:not(:last-child) {
  margin-right: 24px
}

._feature_3a6kq_1 {
  position: relative;
  width: var(--vc-width);
  padding: 0 var(--vc-padding);
  margin: -50px auto 0;
  display: flex;
  justify-content: space-between;
  z-index: 1
}

._featureItem_3a6kq_12 {
  display: flex;
  align-items: center;
  width: 327px;
  height: 100px;
  background: linear-gradient(180deg, #f3f5f8, #ffffff);
  border: 3px solid #ffffff;
  border-radius: 2px;
  box-shadow: 8px 8px 20px #32468112
}

._cover_3a6kq_23 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 77px;
  height: 77px;
  margin-left: 12px;
  margin-right: 12px
}

._cover_3a6kq_23 img {
  width: 100%
}

._content_3a6kq_36 {
  display: flex;
  flex-direction: column;
  justify-content: center
}

._title_3a6kq_42 {
  font-size: var(--font-size-ml);
  font-weight: 700;
  color: #000000e6;
  line-height: 20px
}

._description_3a6kq_49 {
  font-size: var(--font-size-base);
  font-weight: 400;
  color: #0009;
  line-height: 20px;
  margin-top: 15px
}

._tag_1amn3_1 {
  display: inline-flex;
  align-items: center;
  font-size: var(--font-size-text);
  color: var(--vc-primary-color)
}

._tag_1amn3_1:not(:last-child) {
  margin-right: var(--base-margin)
}

._tag_1amn3_1 img {
  width: 19px;
  height: 23px;
  margin-right: 8px
}

._introduction_1v56m_1 {
  width: var(--vc-width);
  padding: 0 var(--vc-padding);
  margin: 0 auto
}

._introductionItem_1v56m_7 {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 350px;
  background: linear-gradient(180deg, #f3f5f8, #ffffff);
  border: 3px solid #ffffff;
  border-radius: 2px;
  box-shadow: 8px 8px 20px #32468108;
  margin-top: var(--base-margin)
}

._content_1v56m_19 {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 50px 48px 60px
}

._title_1v56m_26 {
  font-size: var(--font-size-title);
  font-weight: 800;
  color: #000000e6
}

._description_1v56m_32 {
  width: 560px;
  height: 102px;
  margin-top: 28px;
  font-size: var(--font-size-text);
  font-weight: 300;
  line-height: 34px
}

._desc_1v56m_32 {
  margin-top: 35px
}

._icon_1v56m_45 {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 669px;
  height: 100%
}

._iconImage_1v56m_54 {
  width: 400px;
  z-index: 2
}

._bg_1v56m_59 {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url(./assets/vico/bg.a62066d0.png) no-repeat;
  background-size: cover;
  z-index: 1
}

._right_1v56m_70._introductionItem_1v56m_7 {
  flex-direction: row-reverse
}

._right_1v56m_70 ._title_1v56m_26,
._right_1v56m_70 ._description_1v56m_32 {
  text-align: right
}

._right_1v56m_70 ._bg_1v56m_59 {
  transform: rotateY(-180deg)
}

._slogan_1liym_1 {
  margin-top: var(--base-margin);
  background: #eaeef4;
  height: 447px
}

._container_1liym_7 {
  position: relative;
  width: var(--vc-width);
  padding: 0 var(--vc-padding);
  margin: 0 auto;
  height: 100%;
  box-sizing: border-box;
  padding-top: var(--base-margin);
  padding-bottom: var(--base-margin);
  background: url(./assets/vico/map.1cf7ca23.png);
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center
}

._title_1liym_25 {
  font-size: var(--font-size-title);
  font-weight: 800;
  color: #000000e6
}

._desc_1liym_31 {
  width: 792px;
  font-size: var(--font-size-text);
  text-align: center;
  line-height: 34px;
  margin-top: var(--base-margin);
  color: #000c;
  font-weight: 400
}

._tags_1liym_41 {
  margin-top: 194px
}

._button_1jvl8_1 {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  white-space: nowrap;
  background-image: none;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all .3s cubic-bezier(.645, .045, .355, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  touch-action: manipulation;
  box-sizing: border-box;
  height: 44px;
  padding: 0 30px;
  font-size: var(--font-size-ml);
  border-radius: 5px;
  color: var(--vc-primary-color);
  border-color: var(--vc-primary-color);
  background: #fff;
  text-decoration: none
}

._button_1jvl8_1:hover {
  border-color: var(--vc-primary-hover-color);
  color: var(--vc-primary-hover-color)
}

._button_1jvl8_1._primary_1jvl8_31 {
  color: #fff;
  background: var(--vc-primary-color);
  border-color: var(--vc-primary-color)
}

._button_1jvl8_1._primary_1jvl8_31:hover {
  background: var(--vc-primary-hover-color);
  border-color: var(--vc-primary-hover-color)
}
</style>

<script>
import config from '../../configCenter.json'
export default {
  mounted () {
    document.title = config.companyFullName
  }
}
</script>